import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import axios from "axios";
import ApiURL from "../../../api/ApiURL";
import cogoToast from "cogo-toast";
import dayjs from "dayjs";
import LocalStorageHelper from '../../../LocalStorageHelper/LocalStorageHelper';
import PageTitle from '../../home/PageTitle';
import HotelSubBooking from '../SubBooking/HotelSubBooking';
import CarSubBooking from '../SubBooking/CarSubBooking';
import OtherSubBooking from '../SubBooking/OtherSubBooking';
import TableComponent from '../../common/TableComponent';
import { Link } from 'react-router-dom';
import { Accordion, Card, Button } from "react-bootstrap";
import { FaPlus, FaMinus } from "react-icons/fa";
import MoneyReceiptPreviewModal from '../../reports/MoneyReceipt/MoneyReceiptPreviewModal';
import ConfirmationVoucherPreviewModal from '../../reports/ConfirmationVoucher/ConfirmationVoucherPreviewModal';
import HotelVoucherPreviewModal from '../../reports/HotelVoucher/HotelVoucherPreviewModal';

class ManageBooking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'bookingInfo',
            showModal: false,
            UserId: 0,
            UserRole: "",
            finYearId: 0,
            RedirectToLogin: false,
            bookingData: null,
            columns: [],
            TCData: [],
            bookingTypeData: [],
            //--- Booking Summary Data ---
            bookingId: 0,
            bookingNo: '',
            bookingDate: '',
            firstName: '',
            lastName: '',
            customerName: '',
            mobile: '',
            email: '',
            address: '',
            tripCategory: 'Domestic',
            stateId: 0,
            gstin: '',
            pan: '',
            currentStateCode: '19',
            placeOfSupplyId: 0,
            specialistId: 0,
            tcsReceived: false,
            tcId: '',
            travelCircuitId: '',
            travelDestination: '',
            bookingTypeId: '',
            bookingType: '',
            ticketBooked: '',
            hotelCategory: '',
            journeyStartDate: '',
            journeyEndDate: '',
            journeyStartPoint: '',
            journeyEndPoint: '',
            noOfGuests: '',
            noOfAdults: '',
            noOfChildrens: '',
            packageSoldAmount: 0,
            spotPaidAmount: 0,
            packageCostAmount: 0,
            taxableAmount: 0,
            cgstPercent: 2.5,
            cgstAmount: 0,
            sgstPercent: 2.5,
            sgstAmount: 0,
            igstPercent: 5,
            igstAmount: 0,
            tcsPercent: 5,
            tcsAmount: 0,
            packageProfitAfterTaxAmount: 0,
            ticketSoldAmount: 0,
            ticketCostAmount: 0,
            ticketProfitAmount: 0,
            ticketProfitAfterTaxAmount: 0,
            taxPercentOnTicketProfit: 18,
            taxOnTicketProfitAmount: 0,
            grandTotalSaleAmount: 0,
            grandTotalCostAmount: 0,
            totalTaxAmount: 0,
            netProfit: 0,
            //profitAfterTaxAmount: 0,
            profitMarginPercent: 0,
            totalPayableAmount: 0,
            totalPaidAmount: 0,
            totalDueAmount: 0,
            bookingStatus: 'Active',
            //--Postponed variables--
            cnNumber: '',
            cnDate: '',
            cnAmount: 0,
            //------------------------
            //--Cancelled variables--
            refundDate: '',
            refundAmount: 0,
            refundBank: '',
            bankRefNo: '',
            //------------------------
            isBookingActive: true,
            states: [],
            placeOfSupplies: [],
            specialists: [],
            subBookings: [],
            initialSubBookings: [],
            isSubBookingTableLoading: true,
            isCpTableLoading: false,
            isVpTableLoading: false,
            isSpTableLoading: false,
            additionalCharges: [],
            subBookingType: '',
            redirectBookingListStatus: false,
            //--- Sub-Booking Data ---
            locationData: [],
            vendorCategoryId: 0,
            subBookingId: 0,
            subBookingNo: '',
            locationId: 0,
            vendorId: 0,
            comment: '',
            payableAmount: 0,
            paidAmount: 0,
            dueAmount: 0,
            //--- Hotel Sub-Booking Data ---            
            vendorData: [],
            roomCategoryData: [],
            roomCategoryId: 0,
            noOfRooms: '',
            noOfEB: '',
            noOfCNB: '',
            mealPlan: '',
            checkInDate: '',
            checkOutDate: '',
            noOfDays: '',
            //--- Car Sub-Booking Data ---
            carData: [],
            selectedCar: [],
            carId: '',
            noOfCars: 0,
            pickupPoint: '',
            dropPoint: '',
            //--- Other Sub-Booking Data ---
            otherChargeData: [],
            chargeId: 0,
            chargeDescription: '',

            //--- Customer Payment ---
            showCustPayModal: false,
            cpData: [],
            cpColumns: [],
            cpBookingId: 0,
            custPayId: 0,
            mrNo: '',
            mrDate: '',
            mrAmount: '',
            modeOfPayment: '',
            receivedBank: '',
            cpIsActive: true,
            showMoneyReceiptModal: false,
            moneyReceiptData: null,
            showConfirmationVoucherModal: false,
            confirmationVoucherData: null,
            showHotelVoucherModal: false,
            hotelVoucherData: null,

            //--- Vendor Payment ---
            showVendorPayModal: false,
            vpData: [],
            vpColumns: [],
            vpId: 0,
            vpSubBookingId: 0,
            vpSubBookingNo: '',
            vpTravelCircuitId: 0,
            vpLocationId: 0,
            vpLocationName: '',
            vpSubBookingType: '',
            vpVendorId: 0,
            vpVendorName: '',
            vpPaymentDate: '',
            vpPaidAmount: '',
            vpBankName: '',
            vpComment: '',
            vpDueAmount: 0,
            vpIsActive: true,

            //--- Spot Payment ---
            showSpotPayModal: false,
            spVendorData: [],
            spData: [],
            spColumns: [],
            spId: 0,
            spTravelCircuitId: 0,
            spTravelCircuitName: '',
            spLocationId: 0,
            spLocationName: '',
            spVendorCategoryId: 0,
            spVendorCategoryName: '',
            spVendorId: 0,
            spVendorName: '',
            spPaymentDate: '',
            spSpotAmount: 0,
            spIsAmountPaid: false,
            spComment: '',
            spIsActive: true
        };
    }
    //ComponentDidMount
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                UserId: userData.UserId,
                UserRole: userData.RoleName
            })
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
        this.getBookingData();
        this.getAllStateData();
        this.getAllSpecialistData();
        this.getAllTCData();
        this.getAllBookingTypeData();
        this.getAllSubBookingDataColumns();
        this.getAllCarData();
        this.getAllAdditionalChargeData();
    }

    getBookingData = () => {
        var self = this;
        console.log(self.props.bookingId);
        let param = { BookingId: self.props.bookingId };
        self.setState({ isSubBookingTableLoading: true });
        axios.post(ApiURL.GetBooking, param)
            .then(response => {
                let respData = response.data;
                console.log(respData.DataResult);
                if (respData.StatusCode === 200) {
                    self.setState({
                        bookingData: respData.DataResult
                    }, () => self.loadBookingData())
                } else {
                    self.setState({ isSubBookingTableLoading: false });
                }
            }).catch(error => {
                cogoToast.error("Request Failed! Please Try Again.", { position: 'bottom-center' })
                self.setState({ isSubBookingTableLoading: false });
            });
    }

    //Get Booking Data
    loadBookingData = () => {
        var self = this;
        var bkData = self.state.bookingData;
        console.log('bkData:', bkData);
        if (bkData != null) {
            let pkgCostAmt = bkData.SubBookings.reduce((sum, item) => sum + (parseFloat(item.PayableAmount) || 0), 0);
            //const formattedBookingDate = bkData.CreatedDate.split("T")[0];
            //const formattedJourneyStartDate = bkData.JourneyStartDate.split("T")[0];
            //const formattedJourneyEndDate = bkData.JourneyEndDate.split("T")[0] !== "0001-01-01" ? bkData.JourneyEndDate.split("T")[0] : "";
            self.setState({
                bookingId: bkData.BookingId,
                bookingNo: bkData.BookingNo,
                bookingDate: bkData.BookingDate,
                firstName: bkData.FirstName,
                lastName: bkData.LastName,
                customerName: bkData.CustomerName,
                mobile: bkData.Mobile,
                email: bkData.Email,
                stateId: bkData.StateId,
                placeOfSupplyId: bkData.PlaceOfSupplyId,
                address: bkData.Address,
                tripCategory: bkData.TripCategory,
                specialistId: bkData.SpecialistId,
                gstin: bkData.GSTIN,
                pan: bkData.PAN,
                tcId: bkData.TravelCircuitId,
                travelCircuitId: bkData.TravelCircuitId,
                spTravelCircuitId: bkData.TravelCircuitId,
                travelDestination: bkData.TravelDestination,
                bookingTypeId: bkData.BookingTypeId,
                bookingType: bkData.BookingType,
                ticketBooked: bkData.TicketBooked,
                hotelCategory: bkData.hotelCategory || '',
                journeyStartDate: bkData.JourneyStartDate,
                journeyEndDate: bkData.JourneyEndDate,
                journeyStartPoint: bkData.JourneyStartPoint,
                journeyEndPoint: bkData.JourneyEndPoint,
                noOfGuests: bkData.NoOfGuests,
                noOfAdults: bkData.NoOfAdults,
                noOfChildrens: bkData.NoOfChildrens,
                packageCostAmount: bkData.PackageCostAmount || pkgCostAmt,
                packageSoldAmount: bkData.PackageSoldAmount,
                spotPaidAmount: bkData.SpotAmount,
                packageProfitAfterTaxAmount: bkData.PackageProfitAfterTaxAmount,
                taxableAmount: bkData.TaxableAmount,
                cgstPercent: bkData.CGSTPercent,
                cgstAmount: bkData.CGSTAmount,
                sgstPercent: bkData.SGSTPercent,
                sgstAmount: bkData.SGSTAmount,
                igstPercent: bkData.IGSTPercent,
                igstAmount: bkData.IGSTAmount,
                tcsReceived: bkData.TCSReceived,
                tcsPercent: bkData.TCSPercent,
                tcsAmount: bkData.TCSAmount,

                ticketSoldAmount: bkData.TicketSoldAmount,
                ticketCostAmount: bkData.TicketCostAmount,
                ticketProfitAmount: bkData.TicketProfitAmount,
                ticketProfitAfterTaxAmount: bkData.TicketProfitAfterTaxAmount,
                taxPercentOnTicketProfit: bkData.TaxPercentOnTicketProfit,
                taxOnTicketProfitAmount: bkData.TaxOnTicketProfitAmount,

                grandTotalSaleAmount: bkData.GrandTotalSaleAmount,
                grandTotalCostAmount: bkData.GrandTotalCostAmount,
                totalTaxAmount: bkData.TotalTaxAmount,
                netProfit: bkData.NetProfit,
                //profitAfterTaxAmount: bkData.ProfitAfterTaxAmount,
                profitMarginPercent: bkData.ProfitMarginPercent,

                totalPayableAmount: parseFloat(bkData.PayableAmount),
                totalPaidAmount: bkData.PaidAmount,
                totalDueAmount: bkData.DueAmount,
                bookingStatus: bkData.BookingStatus,
                //----Postponed----
                cnNumber: bkData.CNNumber,
                cnDate: bkData.CNDate,
                cnAmount: bkData.CNAmount,
                //----Cancelled----
                refundDate: bkData.RefundDate,
                refundAmount: bkData.RefundAmount,
                refundBank: bkData.RefundBank,
                bankRefNo: bkData.BankRefNo,

                isBookingActive: bkData.IsActive,
                //To deep clone the array to create two separate copies.
                subBookings: [...bkData.SubBookings],
                initialSubBookings: [...bkData.SubBookings],
                additionalCharges: bkData.AdditionalCharges,
                isSubBookingTableLoading: false,
            }, () => {
                self.getAllCustPayData(bkData.BookingId);
                self.getAllSpotBookingData(this.state.bookingId, 0);
            })
        } else {
            self.setState({ isSubBookingTableLoading: false });
        }
    }
    //Get All Sub-Booking Columns
    getAllSubBookingDataColumns = () => {
        var self = this;
        this.setState({
            columns: [
                {
                    Header: "Action",
                    accessor: "select",
                    minWidth: 155,
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ row }) => (
                        <div className='d-flex table-action-buttons'>
                            <div
                                className="text-center table-action-button"
                                title="Edit"
                                onClick={() => this.handleEdit(row.original)}
                            >
                                <i className="fa-solid fa-pen-to-square"></i>
                            </div>
                            {
                                row.original.SubBookingId > 0 && row.original.SubBookingType === 'Hotel' &&
                                <div
                                    className="text-center table-action-button"
                                    title="Print"
                                    onClick={() => this.handleHotelVoucherPrint(row.original)}
                                >
                                    <i className="fa-solid fa-print"></i>
                                </div>
                            }
                            <div
                                className="text-center table-action-button"
                                title="Remove"
                                onClick={() => this.handleDelete(row.original)}
                            >
                                <i className="fa-regular fa-trash-can"></i>
                            </div>
                            {
                                row.original.SubBookingId > 0 &&
                                <div
                                    className="text-center table-action-button"
                                    title="Vendor Payment"
                                    onClick={() => this.handleVendorPayment(row.original)}
                                >
                                    <i className="fa-solid fa fa-inr"></i>
                                </div>
                            }
                        </div>
                    ),
                },
                { Header: "Sub-Booking #", accessor: "SubBookingNo", disableFilters: true },
                { Header: "Sub-Booking Type", accessor: "SubBookingType", disableFilters: true },
                { Header: "Vendor", accessor: "VendorName", disableFilters: true },
                { Header: "Location", accessor: "LocationName", disableFilters: true },
                {
                    Header: "Booking From",
                    accessor: "CheckInDate",
                    disableFilters: true,
                    className: "text-center",
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value ? moment(value).format('DD-MM-YYYY') : ""} {/* Format to DD-MM-YYYY */}
                        </div>
                    ),
                },
                {
                    Header: "Booking To",
                    accessor: "CheckOutDate",
                    disableFilters: true,
                    className: "text-center",
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value ? moment(value).format('DD-MM-YYYY') : ""} {/* Format to DD-MM-YYYY */}
                        </div>
                    ),
                },
                {
                    Header: "Payable Amount",
                    accessor: "PayableAmount",
                    disableFilters: true,
                    className: "text-right",
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                {
                    Header: "Paid Amount",
                    accessor: "PaidAmount",
                    disableFilters: true,
                    className: "text-right",
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                {
                    Header: "Due Amount",
                    accessor: "DueAmount",
                    disableFilters: true,
                    className: "text-right",
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
            ]
        }, () => {
            self.calculatePackageSummary();
        })
    }
    //Get All Additional Charges
    getAllAdditionalChargeData = () => {
        axios
            .get(ApiURL.GetAllAdditionalCharge)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ otherChargeData: dataResult });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Handle Edit
    handleEdit = async (row) => {
        const { SubBookingType, TravelCircuitId, LocationId, VendorId, CarId } = row;
        var vendorCategoryId = SubBookingType === "Hotel" ? 1 : SubBookingType === "Car" ? 2 : 3;

        // Fetch required data in parallel
        const [locations, vendors, roomCategories, cars, otherCharges] = await Promise.all([
            axios.get(ApiURL.GetAllLocationByTC(TravelCircuitId)).then(res => res.data?.DataResult || []),
            axios.get(ApiURL.GetAllVendorByLocation(LocationId, vendorCategoryId)).then(res => res.data?.DataResult || []),
            SubBookingType === "Hotel"
                ? axios.get(ApiURL.GetAllRoomCategoryByVendor(VendorId)).then(res => res.data?.DataResult || [])
                : Promise.resolve([]),
            SubBookingType === "Car"
                ? axios.get(ApiURL.GetAllCar).then(res => res.data?.DataResult || [])
                : Promise.resolve([]),
            SubBookingType === "Other"
                ? axios.get(ApiURL.GetAllAdditionalCharge).then(res => res.data?.DataResult || [])
                : Promise.resolve([])

        ]);

        // Common state fields
        const newState = {
            //...this.state,
            locationData: locations,
            vendorData: vendors,
            subBookingId: row.SubBookingId,
            subBookingNo: row.SubBookingNo,
            subBookingType: SubBookingType,
            bookingId: row.BookingId,
            travelCircuitId: TravelCircuitId,
            locationId: LocationId,
            vendorId: VendorId,
            checkInDate: row.CheckInDate,
            checkOutDate: row.CheckOutDate,
            comment: row.Comment,
            payableAmount: row.PayableAmount,
            paidAmount: row.PaidAmount,
            dueAmount: row.DueAmount,
            //isActive: row.IsActive,
            showModal: true
        };

        // Additional fields based on SubBookingType
        if (SubBookingType === "Hotel") {
            Object.assign(newState, {
                vendorCategoryId,
                roomCategoryData: roomCategories,
                roomCategoryId: row.RoomCategoryId,
                noOfRooms: row.NoOfRooms,
                noOfEB: row.NoOfEB,
                noOfCNB: row.NoOfCNB,
                mealPlan: row.MealPlan,
                noOfDays: row.NoOfDays
            });
        } else if (SubBookingType === "Car") {
            Object.assign(newState, {
                carData: this.convertListToReactSelectItem(cars, "CarId", "CarName"),
                selectedCar: CarId ? this.convertStringToReactSelectItems(cars, CarId) : [],
                noOfCars: row.NoofCars,
                pickupPoint: row.PickupPoint,
                dropPoint: row.DropPoint
            });
        } else if (SubBookingType === "Other") {
            Object.assign(newState, {
                chargeId: row.ChargeId
            });
        }

        this.setState(newState);
    };
    //Handle Delete
    handleDelete = (row) => {
        var self = this;
        var { subBookings, initialSubBookings } = self.state;
        const index = subBookings.findIndex(a => a.SubBookingNo === row.SubBookingNo);
        if (index !== -1) {
            initialSubBookings[index].IsActive = false;
            subBookings.splice(index, 1);
            self.setState({ subBookings, initialSubBookings }, () => {
                self.getAllSubBookingDataColumns();
            });
        }
    }
    //Handle Vendor Payment
    handleVendorPayment = (row) => {
        var self = this;
        console.log(row);
        if (row) {
            this.setState({
                showVendorPayModal: true,
                vpSubBookingId: row.SubBookingId,
                vpSubBookingNo: row.SubBookingNo,
                vpTravelCircuitId: row.TravelCircuitId,
                vpLocationId: row.LocationId,
                vpLocationName: row.LocationName,
                vpSubBookingType: row.SubBookingType,
                vpVendorId: row.VendorId,
                vpVendorName: row.VendorName,
                vpDueAmount: row.DueAmount
            }, () => {
                self.getAllVendorPayData(row.SubBookingId);
            })
        }
    }

    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ ...this.state, TCData: dataResult });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get All Booking Type Data
    getAllBookingTypeData = () => {
        axios
            .get(ApiURL.GetAllBookingType)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ ...this.state, bookingTypeData: dataResult });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Handle Tab Change
    handleTabChange = (tab) => {
        this.setState({ ...this.state, activeTab: tab });
    }

    //On BookingStatus Change Handler
    onBookingStatusChangeHandler = (e) => {
        var { cnNumber, cnDate, cnAmount, refundDate, refundAmount, refundBank, bankRefNo } = this.state;
        switch (e.target.value) {
            case 'Active':
                cnNumber = cnDate = refundDate = refundBank = bankRefNo = '';
                cnAmount = refundAmount = 0;
                break;
            case 'Postponed':
                refundDate = refundBank = bankRefNo = '';
                refundAmount = 0;
                break;
            case 'Cancelled':
                cnNumber = cnDate = '';
                cnAmount = 0;
                break;
        }
        this.setState({
            bookingStatus: e.target.value,
            cnNumber,
            cnDate,
            cnAmount,
            refundDate,
            refundAmount,
            refundBank,
            bankRefNo
        })
    }

    //On Change handler
    onChangeHandler = (e) => {
        const { name, type, value, checked } = e.target;
        console.log(value);
        let finalValue;
        switch (type) {
            /* case "checkbox":
                finalValue = checked;
                break; */
            case "number":
                finalValue = value === "" ? "" : parseFloat(value);
                break;
            case "radio":
                finalValue = value;
                break;
            case "select-multiple":
                finalValue = Array.from(e.target.selectedOptions, (opt) => opt.value);
                break;
            default:
                finalValue = value;
        }
        if (this.state.bookingTypeId == 1 && name === 'stateId') {
            this.setState({
                [name]: finalValue,
                placeOfSupplyId: finalValue
            })
        }
        else {
            this.setState({ [name]: finalValue });
        }
    };
    //On radio change handler
    onRadioChangeHandler = (e) => {
        var self = this;
        const { type, checked } = e.target;
        let tripCatg = checked ? 'International' : 'Domestic'
        this.setState({
            tcsReceived: checked,
            tripCategory: tripCatg
        }, () => self.calculatePackageSummary());
    }
    //On Blur handler
    onBlurHandler = (e) => {
        let self = this;
        var { placeOfSupplyId, bookingTypeId } = this.state;
        if (bookingTypeId == 0) {
            cogoToast.error("Please select at least one value from `Booking Type`", { position: "top-center" });
            self.setState({ packageSoldAmount: 0 })
        }
        else if (placeOfSupplyId == 0) {
            cogoToast.error("Please select at least one value from `Place of supply`", { position: "top-center" });
            self.setState({ packageSoldAmount: 0 })
        }
        else {
            const val = parseFloat(e.target.value);
            if (!isNaN(val)) {
                self.setState({
                    [e.target.name]: val.toFixed(2)
                }, () => {
                    self.calculatePackageSummary();
                });
            }
        }
    }
    //On Change Handler
    subBookingHandler = (e) => {
        if (e.target.name === 'travelCircuitId') {
            this.getAllLocationData(e.target.value)
        }
        if (e.target.name === 'locationId') {
            this.getAllVendorData(e.target.value, this.state.vendorCategoryId);
        }
        if (e.target.name === 'vendorId') {
            let subBkType = this.state.subBookingType;
            if (subBkType === "Hotel") {
                this.getAllRoomCategoryData(e.target.value);
            }
        }
        if (e.target.name === 'checkInDate') {
            const date1 = dayjs(e.target.value);
            const date2 = dayjs(this.state.checkOutDate);
            // Calculate the difference in days
            if (date1 !== '' && date2 !== '') {
                let diffInDays = date2.diff(date1, 'day') || 0;
                this.setState({ noOfDays: diffInDays })
            }
        }
        if (e.target.name === 'checkOutDate') {
            const date1 = dayjs(this.state.checkInDate);
            const date2 = dayjs(e.target.value);
            // Calculate the difference in days
            if (date1 !== '' && date2 !== '') {
                let diffInDays = date2.diff(date1, 'day') || 0;
                this.setState({ noOfDays: diffInDays })
            }
        }
        if (e.target.name === 'payableAmount') {
            let payableAmt = parseFloat(e.target.value) || 0;
            let paidAmt = parseFloat(this.state.paidAmount) || 0;
            let dueAmt = payableAmt - paidAmt;
            this.setState({ dueAmount: dueAmt })
        }

        this.setState({
            [e.target.name]: e.target.value
        });
    }
    //On Change Car Event
    onChangeCarHandler = (selected) => {
        var self = this;
        self.setState({
            selectedCar: selected,
            noOfCars: selected.length
        })
    }
    //Get all Location data
    getAllLocationData = (tcId) => {
        axios
            .get(ApiURL.GetAllLocationByTC(tcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ locationData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ locationData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Vendor data
    getAllVendorData = (locId, vcId) => {
        axios
            .get(ApiURL.GetAllVendorByLocation(locId, vcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ vendorData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ vendorData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get Vendor data
    getVendorDataList = (locId, vcId) => {
        let dataList = [];
        axios
            .get(ApiURL.GetAllVendorByLocation(locId, vcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    dataList = respData.DataResult;
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });

        return dataList;
    }
    //Get all HotelRoomCategory data
    getAllRoomCategoryData = (vendorId) => {
        axios
            .get(ApiURL.GetAllRoomCategoryByVendor(vendorId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ roomCategoryData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ roomCategoryData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all HotelRoomCategory data
    getAllCarData = () => {
        axios
            .get(ApiURL.GetAllCar)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    let reactSelectCarData = this.convertListToReactSelectItem(dataResult, "CarId", "CarName");
                    this.setState({ carData: reactSelectCarData });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ carData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all State data
    getAllStateData = () => {
        axios
            .get(ApiURL.GetAllState)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    const dataResult = respData.DataResult || [];

                    const { stateData, placeOfSupplyData } = dataResult.reduce(
                        (acc, item) => {
                            acc.stateData.push({
                                StateId: item.StateId,
                                StateCode: item.Code,
                                StateName: item.StateName
                            });
                            acc.placeOfSupplyData.push({
                                PlaceOfSupplyId: item.StateId,
                                PlaceOfSupplyCode: item.Code,
                                PlaceOfSupplyName: item.StateName
                            });
                            return acc;
                        },
                        { stateData: [], placeOfSupplyData: [] }
                    );
                    this.setState({
                        states: stateData,
                        placeOfSupplies: placeOfSupplyData
                    });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ states: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Specialist data
    getAllSpecialistData = () => {
        axios
            .get(ApiURL.GetAllSPL)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    const dataResult = respData.DataResult || [];

                    const { specialistData } = dataResult.reduce(
                        (acc, item) => {
                            acc.specialistData.push({
                                SpecialistId: item.SpecialistId,
                                SpecialistName: item.SpecialistName
                            });
                            return acc;
                        },
                        { specialistData: [] }
                    );
                    this.setState({ specialists: specialistData });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ states: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Convert List To React Select Item
    convertListToReactSelectItem = (list, valueKey, labelKey) => {
        if (!Array.isArray(list)) return [];

        return list.map(item => ({
            value: item[valueKey],
            label: item[labelKey]
        }));
    };
    /*convertListToReactSelectItem = (carList) => {
        var myData = [];
        for (var i = 0; i < carList.length; i++) {
            myData.push({
                value: carList[i].CarId,
                label: carList[i].CarName
            })
        }
        return myData;
    }*/
    //Convert String To React Select Items
    convertStringToReactSelectItems = (cars, carIds) => {
        const idArray = carIds.split(",").map(id => id.trim());
        var selectedItems = [];
        for (var i = 0; i < idArray.length; i++) {
            let carId = parseInt(idArray[i]);
            let selectedCar = cars.filter((car) => car.CarId === carId)[0];
            if (selectedCar !== null) {
                let temp = {
                    label: selectedCar.CarName,
                    value: selectedCar.CarId,
                    clearableValue: true
                }
                selectedItems.push(temp);
            }

        }
        return selectedItems;
    }
    //CalCulate Package Summary
    round2 = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;
    roundTo = (value, decimals = 0) => {
        const factor = Math.pow(10, decimals);
        return Math.round((Number(value) + Number.EPSILON) * factor) / factor;
    };

    calculatePackageSummary = () => {
        let {
            bookingTypeId,
            placeOfSupplies,
            placeOfSupplyId,
            currentStateCode,
            subBookings = [],
            packageSoldAmount = 0,
            spotPaidAmount = 0,
            cgstPercent = 0,
            sgstPercent = 0,
            igstPercent = 0,
            tcsReceived,
            tcsPercent = 0,
            ticketSoldAmount = 0,
            ticketCostAmount = 0,
            taxPercentOnTicketProfit = 0,
            totalPaidAmount = 0
        } = this.state;

        const placeOfSupplyCode =
            placeOfSupplies?.find(p => p.PlaceOfSupplyId === Number(placeOfSupplyId))
                ?.PlaceOfSupplyCode;

        /* ---------------- ORIGINAL AMOUNTS ---------------- */
        const originalSoldAmount = Number(packageSoldAmount) - Number(spotPaidAmount);

        const packageCostAmount = this.roundTo(
            subBookings.reduce((sum, item) => sum + (Number(item.PayableAmount) || 0), 0)
        );

        const originalCostAmount = packageCostAmount + Number(spotPaidAmount);

        /* ---------------- TAXABLE AMOUNT ---------------- */
        const totalTaxablePercent = igstPercent + (tcsReceived ? tcsPercent : 0);

        const taxableAmount = this.roundTo(
            (originalSoldAmount * 100) / (100 + totalTaxablePercent));

        /* ---------------- GST ---------------- */
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (bookingTypeId === 1) { // B2B
            if (placeOfSupplyCode === currentStateCode) {
                cgstAmount = this.roundTo(taxableAmount * cgstPercent / 100);
                sgstAmount = this.roundTo(taxableAmount * sgstPercent / 100);
            } else {
                igstAmount = this.roundTo(taxableAmount * igstPercent / 100);
            }
        } else if (bookingTypeId === 2) { // B2C
            cgstAmount = this.roundTo(taxableAmount * cgstPercent / 100);
            sgstAmount = this.roundTo(taxableAmount * sgstPercent / 100);
        }

        /* ---------------- TCS ---------------- */
        const tcsAmount = tcsReceived
            ? this.roundTo(taxableAmount * tcsPercent / 100)
            : 0;

        /* ---------------- PACKAGE PROFIT ---------------- */
        const packageProfitAfterTaxAmount = this.roundTo(
            Number(packageSoldAmount) -
            originalCostAmount -
            cgstAmount -
            sgstAmount -
            igstAmount -
            tcsAmount
        );

        /* ---------------- TICKET ---------------- */
        const ticketProfitAmount = this.roundTo(
            Number(ticketSoldAmount) - Number(ticketCostAmount)
        );

        const ticketProfitAfterTaxAmount = this.roundTo(
            (ticketProfitAmount * 100) / (100 + taxPercentOnTicketProfit)
        );

        const taxOnTicketProfitAmount = this.roundTo(
            ticketProfitAfterTaxAmount * taxPercentOnTicketProfit / 100
        );

        /* ---------------- GRAND TOTAL ---------------- */
        const grandTotalSaleAmount = this.roundTo(
            Number(packageSoldAmount) + Number(ticketSoldAmount)
        );

        const grandTotalCostAmount = this.roundTo(
            originalCostAmount + Number(ticketCostAmount)
        );

        const totalTaxAmount = this.roundTo(
            cgstAmount +
            sgstAmount +
            igstAmount +
            tcsAmount +
            taxOnTicketProfitAmount
        );

        const netProfit = this.roundTo(
            grandTotalSaleAmount - grandTotalCostAmount - totalTaxAmount
        );

        const profitMarginPercent = grandTotalSaleAmount === 0
            ? 0
            : this.roundTo(((netProfit * 100) / grandTotalSaleAmount), 2);

        /* ---------------- PAYABLE ---------------- */
        const totalPayableAmount = this.roundTo(packageSoldAmount);
        const totalDueAmount = this.roundTo(totalPayableAmount - Number(totalPaidAmount));

        /* ---------------- SET STATE ---------------- */
        this.setState({
            packageCostAmount,
            taxableAmount,
            cgstAmount,
            sgstAmount,
            igstAmount,
            tcsAmount,
            packageProfitAfterTaxAmount,
            ticketProfitAmount,
            ticketProfitAfterTaxAmount,
            taxOnTicketProfitAmount,
            grandTotalSaleAmount,
            grandTotalCostAmount,
            totalTaxAmount,
            netProfit,
            profitMarginPercent,
            totalPayableAmount,
            totalDueAmount
        });
    };


    /*calculatePackageSummary = () => {
        var self = this;
        var { bookingTypeId, placeOfSupplies, placeOfSupplyId, currentStateCode, subBookings, packageCostAmount,
            packageSoldAmount, cgstPercent, sgstPercent, igstPercent, taxableAmount, packageProfitAfterTaxAmount,
            cgstAmount, sgstAmount, igstAmount, tcsReceived, tcsPercent, tcsAmount, spotPaidAmount,
            ticketSoldAmount, ticketCostAmount, ticketProfitAmount, ticketProfitAfterTaxAmount, taxPercentOnTicketProfit,
            taxOnTicketProfitAmount, grandTotalSaleAmount, grandTotalCostAmount, totalTaxAmount, netProfit,
            profitAfterTaxAmount, profitMarginPercent, totalPayableAmount, totalPaidAmount, totalDueAmount
        } = this.state;

        console.log(this.state);

        const placeOfSupplyCode = placeOfSupplies?.find(a => a.PlaceOfSupplyId == parseInt(placeOfSupplyId))?.PlaceOfSupplyCode;
        const totalTaxablePercent = igstPercent + (tcsReceived ? tcsPercent : 0);
        packageCostAmount = subBookings.reduce((sum, item) => sum + (parseFloat(item.PayableAmount) || 0), 0);
        //taxableAmount = parseFloat(((packageSoldAmount * 100) / (100 + totalTaxablePercent)).toFixed(2));
        taxableAmount = (parseFloat(packageSoldAmount) - parseFloat(spotPaidAmount)) * 100 / (100 + totalTaxablePercent);
        console.log(taxableAmount);

        //Booking Type B2B -> 1 
        if (bookingTypeId == 1) {
            cgstAmount = (placeOfSupplyCode === currentStateCode) ? (taxableAmount * cgstPercent / 100) : 0;
            sgstAmount = (placeOfSupplyCode === currentStateCode) ? (taxableAmount * sgstPercent / 100) : 0;
            igstAmount = (placeOfSupplyCode !== currentStateCode) ? (taxableAmount * igstPercent / 100) : 0;
        }
        //Booking Type B2C -> 2
        else if (bookingTypeId == 2) {
            cgstAmount = taxableAmount * cgstPercent / 100;
            sgstAmount = taxableAmount * sgstPercent / 100;
            igstAmount = 0;
        }
        tcsAmount = tcsReceived ? (taxableAmount * tcsPercent / 100) : 0;
        packageProfitAfterTaxAmount = packageSoldAmount - spotPaidAmount - packageCostAmount - cgstAmount - sgstAmount - igstAmount - tcsAmount;

        //Air/Train ticket calculation
        ticketProfitAmount = parseFloat(ticketSoldAmount) - parseFloat(ticketCostAmount);
        ticketProfitAfterTaxAmount = (ticketProfitAmount * 100) / (100 + taxPercentOnTicketProfit);
        taxOnTicketProfitAmount = ticketProfitAfterTaxAmount * taxPercentOnTicketProfit / 100;

        //Calculate Grand Total
        grandTotalSaleAmount = parseFloat(packageSoldAmount) + parseFloat(ticketSoldAmount);
        grandTotalCostAmount = parseFloat(packageCostAmount) + parseFloat(ticketCostAmount);
        netProfit = grandTotalSaleAmount - grandTotalCostAmount;
        profitAfterTaxAmount = parseFloat(packageProfitAfterTaxAmount.toFixed(2)) + parseFloat(ticketProfitAfterTaxAmount.toFixed(2));
        profitMarginPercent = grandTotalSaleAmount == 0 ? 0 : profitAfterTaxAmount / grandTotalSaleAmount * 100;
        totalPayableAmount = parseFloat(packageSoldAmount);
        totalDueAmount = totalPayableAmount - totalPaidAmount;

        this.setState({
            packageCostAmount, packageSoldAmount, cgstPercent, sgstPercent, igstPercent, taxableAmount,
            packageProfitAfterTaxAmount, cgstAmount, sgstAmount, igstAmount, tcsReceived, tcsPercent, tcsAmount,
            ticketSoldAmount, ticketCostAmount, ticketProfitAmount, ticketProfitAfterTaxAmount, taxPercentOnTicketProfit,
            taxOnTicketProfitAmount, grandTotalSaleAmount, grandTotalCostAmount, netProfit,
            profitAfterTaxAmount, profitMarginPercent, totalPayableAmount, totalPaidAmount, totalDueAmount
        });
        
    }*/
    /* calCulatePackageSummary = () => {     
        let {
            packageCostAmount, packageSoldAmount, profitPercent, packageProfitAfterTaxAmount, taxableAmount, cgstPercent,
            cgstAmount, sgstPercent, sgstAmount, igstPercent, igstAmount, payableAmount, paidAmount, dueAmount
        } = this.state;

        // Ensure all values are treated as numbers
        packageCostAmount = this.state.subBookings.reduce((sum, item) => sum + (item.PayableAmount || 0), 0);;
        packageSoldAmount = parseFloat(packageSoldAmount) || 0;
        cgstPercent = parseFloat(cgstPercent) || 0;
        sgstPercent = parseFloat(sgstPercent) || 0;
        igstPercent = parseFloat(igstPercent) || 0;
        paidAmount = parseFloat(paidAmount) || 0;

        taxableAmount = parseFloat(((packageSoldAmount * 100) / (100 + igstPercent)).toFixed(2));
        packageProfitAfterTaxAmount = parseFloat((taxableAmount - packageCostAmount).toFixed(2));
        profitPercent = packageCostAmount !== 0 ? parseFloat(((packageProfitAfterTaxAmount / packageCostAmount) * 100).toFixed(2)) : 0;
        cgstAmount = parseFloat((taxableAmount * cgstPercent / 100).toFixed(2));
        sgstAmount = parseFloat((taxableAmount * sgstPercent / 100).toFixed(2));
        igstAmount = parseFloat((taxableAmount * igstPercent / 100).toFixed(2));
        payableAmount = parseFloat(packageSoldAmount.toFixed(2));
        dueAmount = parseFloat((payableAmount - paidAmount).toFixed(2));

        this.setState({
            ...this.state,
            packageCostAmount, packageSoldAmount, profitPercent, packageProfitAfterTaxAmount, taxableAmount,
            cgstPercent, cgstAmount, sgstPercent, sgstAmount, igstPercent, igstAmount,
            payableAmount, paidAmount, dueAmount
        });
    }; */

    //Handle Reload
    handleReload = () => {
        window.location.reload();
    }
    //Handle Add New Record
    handleAddNew = (e) => {
        e.preventDefault();
        if (this.state.subBookingType === 'Hotel'
            || this.state.subBookingType === 'Car'
            || this.state.subBookingType === 'Other') {
            this.setState({
                ...this.state,
                subBookingId: 0,
                subBookingNo: '',
                bookingId: this.state.bookingId,
                locationData: [],
                vendorData: [],
                //--- Hotel Sub-Booking Data --- 
                roomCategoryData: [],
                travelCircuitId: 0,
                locationId: 0,
                vendorId: 0,
                roomCategoryId: 0,
                noOfRooms: '',
                noOfEB: '',
                noOfCNB: '',
                mealPlan: '',
                checkInDate: '',
                checkOutDate: '',
                noOfDays: 0,
                //--- Car Sub-Booking Data ---                
                selectedCar: [],
                carId: '',
                noOfCars: 0,
                pickupPoint: '',
                dropPoint: '',
                //--- Other Sub-Booking Data ---
                chargeId: 0,
                chargeDescription: '',
                //--------------
                comment: '',
                payableAmount: 0,
                paidAmount: 0,
                dueAmount: 0,
                //isActive: true,
                showModal: true
            });
        }
    }
    //sub-booking On Change Handler
    subBookingOnChangeHandler = (e) => {
        let vendorType = e.target.value;
        let selectedVendorCategoryId = (vendorType === "Hotel") ? 1 : (vendorType === "Car") ? 2 : 3;
        this.setState({
            vendorCategoryId: selectedVendorCategoryId,
            [e.target.name]: e.target.value
        })
    }
    /* //Save Sub-Booking
    saveSubBooking = (e) => {
        e.preventDefault();
        const {
            subBookingType, travelCircuitId, locationId, vendorId,
            subBookingNo, subBookingId, bookingId, checkInDate, checkOutDate,
            comment, payableAmount, paidAmount, dueAmount, 
            TCData, locationData, vendorData, otherChargeData, chargeId,
            roomCategoryId, noOfRooms, noOfEB, noOfCNB, mealPlan, noOfDays,
            selectedCar, noOfCars, pickupPoint, dropPoint
        } = this.state;

        if (!['Hotel', 'Car', 'Other'].includes(subBookingType)) return;

        const getNameById = (data, idField, id, nameField) =>
            data.find(v => v[idField] === parseInt(id))?.[nameField] || '';

        const selectedTravelCircuitId = parseInt(travelCircuitId) || 0;
        const selectedLocationId = parseInt(locationId) || 0;
        const selectedVendorId = parseInt(vendorId) || 0;
        const selectedBookingNo = subBookingNo ? subBookingNo : dayjs(new Date()).format('DDMMYYhhmmss');

        let subBooking = {
            SubBookingId: subBookingId,
            SubBookingNo: selectedBookingNo,
            SubBookingType: subBookingType,
            BookingId: bookingId,
            TravelCircuitId: selectedTravelCircuitId,
            TravelCircuitName: getNameById(TCData, 'TravelCircuitId', selectedTravelCircuitId, 'TravelCircuitName'),
            LocationId: selectedLocationId,
            LocationName: getNameById(locationData, 'LocationId', selectedLocationId, 'LocationName'),
            VendorId: selectedVendorId,
            VendorName: getNameById(vendorData, 'VendorId', selectedVendorId, 'VendorName'),
            CheckInDate: checkInDate,
            CheckOutDate: checkOutDate,
            Comment: comment,
            PayableAmount: parseFloat(payableAmount),
            PaidAmount: paidAmount,
            DueAmount: dueAmount,
            //IsActive: isActive
        };

        if (subBookingType === 'Hotel') {
            subBooking = {
                ...subBooking,
                RoomCategoryId: parseInt(roomCategoryId) || 0,
                NoOfRooms: noOfRooms,
                NoOfEB: noOfEB,
                NoOfCNB: noOfCNB,
                MealPlan: mealPlan,
                NoOfDays: noOfDays
            };
        } else if (subBookingType === 'Car') {
            subBooking = {
                ...subBooking,
                CarId: selectedCar.map(item => item.value)?.toString() || '',
                NoOfCars: noOfCars,
                PickupPoint: pickupPoint,
                DropPoint: dropPoint
            };
        } else if (subBookingType === 'Other') {
            subBooking = {
                ...subBooking,
                VendorId: parseInt(chargeId) || 0,
                VendorName: getNameById(otherChargeData, 'ChargeId', chargeId, 'ChargeDescription')
            };
        }

        this.addSubBookings(subBooking);
        console.log(this.state.subBookings);
    }; */

    //Add Sub Bookings
    addSubBookings = (subBookingData) => {
        var self = this;
        var updatedSubBookings = self.state.subBookings;
        const index = updatedSubBookings.findIndex(
            (sub) => sub.SubBookingNo === subBookingData.SubBookingNo
        );
        if (index !== -1) {
            // Update existing entry
            updatedSubBookings[index] = { ...updatedSubBookings[index], ...subBookingData };
        } else {
            // Add new entry            
            updatedSubBookings.push(subBookingData);
        }
        self.setState({
            ...self.state,
            subBookingType: '',
            subBookings: [...updatedSubBookings],
            initialSubBookings: [...updatedSubBookings]
        }, () => {
            console.log(this.state.subBookings);
            console.log(this.state.initialSubBookings);
            self.closeModal();
            self.getAllSubBookingDataColumns();
        })
    }
    //Reset Fields
    resetFields = () => {
        this.setState({
            subBookingId: 0,
            subBookingNo: '',
            subBookingType: '',
            travelCircuitId: 0,
            locationId: 0,
            vendorId: 0,
            roomCategoryId: 0,
            noOfRooms: '',
            noOfEB: '',
            noOfCNB: '',
            mealPlan: '',
            checkInDate: '',
            checkOutDate: '',
            noOfDays: '',
            CarId: '',
            NoOfCars: '',
            PickupPoint: '',
            DropPoint: '',
            chargeId: 0,
            chargeDescription: '',
            comment: '',
            /* totalPayableAmount: 0,
            totalPaidAmount: 0,
            totalDueAmount: 0,*/
            isActive: true,
            //Customer payment details
            custPayId: 0,
            mrNo: '',
            mrDate: '',
            mrAmount: '',
            modeOfPayment: '',
            receivedBank: '',
        })
    }
    //Open Modal
    openModal = () => {
        this.setState({
            showModal: true,
        });
    }
    //Close Modal
    closeModal = () => {
        let self = this;
        this.setState({ showModal: false }, () => self.resetFields());
    };
    //Update Booking
    updateBooking = (e) => {
        e.preventDefault();
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            let userId = userData.UserId;
            const { bookingId, bookingNo, bookingDate, address, tripCategory, stateId, gstin, pan,
                placeOfSupplyId, specialistId, tcId, bookingTypeId, ticketBooked, journeyStartDate,
                journeyEndDate, journeyStartPoint, journeyEndPoint, noOfGuests, noOfAdults, noOfChildrens,
                packageSoldAmount, packageCostAmount, spotPaidAmount, packageProfitAfterTaxAmount, taxableAmount,
                cgstPercent, cgstAmount, sgstPercent, sgstAmount, igstPercent, igstAmount,
                tcsReceived, tcsPercent, tcsAmount, ticketSoldAmount, ticketCostAmount, ticketProfitAmount,
                ticketProfitAfterTaxAmount, taxPercentOnTicketProfit, taxOnTicketProfitAmount,
                grandTotalSaleAmount, grandTotalCostAmount, netProfit, profitMarginPercent,
                totalPayableAmount, totalPaidAmount, totalDueAmount, bookingStatus,
                cnNumber, cnDate, cnAmount, refundDate, refundAmount, refundBank, bankRefNo,
                initialSubBookings, isBookingActive } = this.state;

            if (parseInt(stateId || 0) === 0) {
                cogoToast.error("State is required!", { position: "bottom-center" });
            }
            else if (parseInt(placeOfSupplyId || 0) === 0) {
                cogoToast.error("Place of supply is required!", { position: "bottom-center" });
            }
            else if (parseInt(specialistId || 0) === 0) {
                cogoToast.error("Specialist is required!", { position: "bottom-center" });
            }
            else if (parseInt(tcId || 0) === 0) {
                cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
            }
            else if (parseInt(bookingTypeId || 0) === 0) {
                cogoToast.error("Booking Type is required!", { position: "bottom-center" });
            }
            else if (bookingDate === '') {
                cogoToast.error("Booking date is required!", { position: "bottom-center" });
            }
            else if (journeyStartDate === '') {
                cogoToast.error("Journey start date is required!", { position: "bottom-center" });
            }
            else if (journeyEndDate === '') {
                cogoToast.error("Journey end date is required!", { position: "bottom-center" });
            }
            else if (bookingDate !== '' && journeyStartDate !== '' && dayjs(bookingDate) > dayjs(journeyStartDate)) {
                cogoToast.error("Booking date should not be greater than Journey start date!", { position: "bottom-center" });
            }
            else if (journeyStartDate !== '' && journeyEndDate !== '' && dayjs(journeyStartDate) > dayjs(journeyEndDate)) {
                cogoToast.error("Journey start date should not be greater or equal to Journey end date!", { position: "bottom-center" });
            }
            else if (journeyStartPoint === '') {
                cogoToast.error("Journey start point is required!", { position: "bottom-center" });
            }
            else if (journeyEndPoint === '') {
                cogoToast.error("Journey end point is required!", { position: "bottom-center" });
            }
            else if (ticketBooked === '') {
                cogoToast.error("Ticket booked is required!", { position: "bottom-center" });
            }
            else if (noOfGuests === '') {
                cogoToast.error("No. of guest is required!", { position: "bottom-center" });
            }
            else if (bookingTypeId == 1 && gstin === '') {
                cogoToast.error("GSTIN is required!", { position: "bottom-center" });
            }
            else if (bookingTypeId == 1 && pan === '') {
                cogoToast.error("PAN is required!", { position: "bottom-center" });
            }
            else if (packageSoldAmount === 0) {
                cogoToast.error("Package sold price must be greater than zero!", { position: "bottom-center" });
            }
            else if (bookingStatus === 'Postponed' && cnNumber === '') {
                cogoToast.error("CN number is required!", { position: "bottom-center" });
            }
            else if (bookingStatus === 'Postponed' && cnDate === '') {
                cogoToast.error("CN date is required!", { position: "bottom-center" });
            }
            else if (bookingStatus === 'Postponed' && cnAmount === 0) {
                cogoToast.error("CN amount must be greater than zero!", { position: "bottom-center" });
            }
            else if (bookingStatus === 'Cancelled' && refundDate === '') {
                cogoToast.error("Refund date is required!", { position: "bottom-center" });
            }
            else if (bookingStatus === 'Cancelled' && refundAmount === 0) {
                cogoToast.error("Refund amount must be greater than zero!", { position: "bottom-center" });
            }
            else if (bookingStatus === 'Cancelled' && refundBank === '') {
                cogoToast.error("Refund bank is required!", { position: "bottom-center" });
            }
            else if (bookingStatus === 'Cancelled' && bankRefNo === 0) {
                cogoToast.error("Bank Ref. number is required!", { position: "bottom-center" });
            }
            else {
                var finalSubBookings = initialSubBookings.map(sb => {
                    if (sb.SubBookingId === 0 && sb.IsActive === false) {
                        return null;
                    } else {
                        return sb;
                    }
                }).filter(sb => sb !== null);
                console.log(finalSubBookings);
                let param = {
                    BookingId: bookingId,
                    BookingNo: bookingNo,
                    Address: address,
                    TripCategory: tripCategory,
                    StateId: stateId,
                    PlaceOfSupplyId: placeOfSupplyId,
                    GSTIN: gstin,
                    PAN: pan,
                    SpecialistId: specialistId,
                    TravelCircuitId: tcId,
                    BookingTypeId: bookingTypeId,
                    BookingDate: bookingDate,
                    TicketBooked: ticketBooked,
                    JourneyStartDate: journeyStartDate,
                    JourneyEndDate: journeyEndDate,
                    JourneyStartPoint: journeyStartPoint,
                    JourneyEndPoint: journeyEndPoint,
                    NoOfGuests: noOfGuests,
                    NoOfAdults: noOfAdults,
                    NoOfChildrens: noOfChildrens,
                    //----Summary calculated amount----
                    PackageCostAmount: packageCostAmount,
                    PackageSoldAmount: packageSoldAmount,
                    SpotAmount: spotPaidAmount,
                    TaxableAmount: taxableAmount,
                    CGSTPercent: cgstPercent,
                    CGSTAmount: cgstAmount,
                    SGSTPercent: sgstPercent,
                    SGSTAmount: sgstAmount,
                    IGSTPercent: igstPercent,
                    IGSTAmount: igstAmount,
                    TcsReceived: tcsReceived,
                    TcsPercent: tcsPercent,
                    TcsAmount: tcsAmount,
                    PackageProfitAfterTaxAmount: packageProfitAfterTaxAmount,
                    TicketSoldAmount: ticketSoldAmount,
                    TicketCostAmount: ticketCostAmount,
                    TicketProfitAmount: ticketProfitAmount,
                    TicketProfitAfterTaxAmount: ticketProfitAfterTaxAmount,
                    TaxPercentOnTicketProfit: taxPercentOnTicketProfit,
                    TaxOnTicketProfitAmount: taxOnTicketProfitAmount,
                    GrandTotalSaleAmount: grandTotalSaleAmount,
                    GrandTotalCostAmount: grandTotalCostAmount,
                    NetProfit: netProfit,
                    //ProfitAfterTaxAmount: profitAfterTaxAmount,
                    ProfitMarginPercent: profitMarginPercent,
                    PayableAmount: totalPayableAmount,
                    PaidAmount: totalPaidAmount,
                    DueAmount: totalDueAmount,
                    BookingStatus: bookingStatus,
                    //----Postponed----
                    CNNumber: cnNumber,
                    CNDate: cnDate,
                    CNAmount: cnAmount,
                    //----Cancelled----
                    RefundDate: refundDate,
                    RefundAmount: refundAmount,
                    RefundBank: refundBank,
                    BankRefNo: bankRefNo,
                    //-----------------
                    UserId: userId,
                    IsActive: isBookingActive,
                    SubBookings: finalSubBookings
                }
                //console.log(param);
                axios
                    .post(ApiURL.UpdateBooking, param)
                    .then((response) => {
                        let respData = response.data;
                        console.log(respData);
                        if (respData.StatusCode === 200) {
                            cogoToast.success(respData.Message, { position: "bottom-center" });
                            //this.resetInputFields();
                            //this.getAllLeadData();
                        }
                        else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                            cogoToast.warn(respData.Message, { position: "bottom-center" });
                        }
                        else if (respData.StatusCode === 500) {
                            cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                        }
                    })
                    .catch((error) => {
                        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                    });
            }
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
    }

    /* renderSelect = (label, name, value, options) => (
        <div className="col-md-4">
            <label className="form-label">{label} *</label>
            <select
                name={name}
                value={value}
                className="form-control-sm border border-primary form-select w-100"
                onChange={this.subBookingHandler}
            >
                <option value="0">-- Select --</option>
                {options.map((item, index) => (
                    <option key={index} value={item.id || item.value}>
                        {item.name || item.label}
                    </option>
                ))}
            </select>
        </div>
    );

    renderInput = (label, name, value, type = "text", disabled = false) => (
        <div className="col-md-4">
            <label className="form-label">{label} *</label>
            <input
                type={type}
                name={name}
                className="form-control-sm border border-primary w-100"
                value={value}
                disabled={disabled}
                onChange={this.subBookingHandler}
            />
        </div>
    ); */

    openSubBookingModal = () => {
        var myModal = <div></div>;
        if (this.state.subBookingType === 'Hotel') {
            myModal = (<HotelSubBooking
                tcData={this.state.TCData}
                locationData={this.state.locationData}
                vendorData={this.state.vendorData}
                roomCategoryData={this.state.roomCategoryData}
                vendorCategoryId={this.state.vendorCategoryId}
                subBookingId={this.state.subBookingId}
                subBookingNo={this.state.subBookingNo}
                subBookingType={this.state.subBookingType}
                bookingId={this.state.bookingId}
                travelCircuitId={this.state.travelCircuitId}
                locationId={this.state.locationId}
                vendorId={this.state.vendorId}
                roomCategoryId={this.state.roomCategoryId}
                noOfRooms={this.state.noOfRooms}
                noOfEB={this.state.noOfEB}
                noOfCNB={this.state.noOfCNB}
                mealPlan={this.state.mealPlan}
                checkInDate={this.state.checkInDate}
                checkOutDate={this.state.checkOutDate}
                noOfDays={this.state.noOfDays}
                comment={this.state.comment}
                payableAmount={this.state.payableAmount}
                paidAmount={this.state.paidAmount}
                dueAmount={this.state.dueAmount}
                userId={this.state.UserId}
                isActive={this.state.isActive}
                showModal={this.state.showModal}
                closeModal={this.closeModal}
                addSubBookings={this.addSubBookings}
                subBookingHandler={this.subBookingHandler}
            />)
        }
        else if (this.state.subBookingType === 'Car') {
            myModal = (<CarSubBooking
                tcData={this.state.TCData}
                locationData={this.state.locationData}
                vendorData={this.state.vendorData}
                carData={this.state.carData}
                vendorCategoryId={this.state.vendorCategoryId}
                subBookingId={this.state.subBookingId}
                subBookingNo={this.state.subBookingNo}
                subBookingType={this.state.subBookingType}
                bookingId={this.state.bookingId}
                travelCircuitId={this.state.travelCircuitId}
                locationId={this.state.locationId}
                vendorId={this.state.vendorId}
                carId={this.state.carId}
                selectedCar={this.state.selectedCar}
                noOfCars={this.state.noOfCars}
                checkInDate={this.state.checkInDate}
                checkOutDate={this.state.checkOutDate}
                pickupPoint={this.state.pickupPoint}
                dropPoint={this.state.dropPoint}
                comment={this.state.comment}
                payableAmount={this.state.payableAmount}
                paidAmount={this.state.paidAmount}
                dueAmount={this.state.dueAmount}
                userId={this.state.UserId}
                isActive={this.state.isActive}
                showModal={this.state.showModal}
                closeModal={this.closeModal}
                addSubBookings={this.addSubBookings}
                subBookingHandler={this.subBookingHandler}
                onChangeCarHandler={this.onChangeCarHandler}
            />)
        }
        else if (this.state.subBookingType === 'Other') {
            myModal = (<OtherSubBooking
                tcData={this.state.TCData}
                locationData={this.state.locationData}
                otherChargeData={this.state.otherChargeData}
                subBookingId={this.state.subBookingId}
                subBookingNo={this.state.subBookingNo}
                subBookingType={this.state.subBookingType}
                bookingId={this.state.bookingId}
                travelCircuitId={this.state.travelCircuitId}
                locationId={this.state.locationId}
                chargeId={this.state.chargeId}
                checkInDate={this.state.checkInDate}
                checkOutDate={this.state.checkOutDate}
                comment={this.state.comment}
                payableAmount={this.state.payableAmount}
                paidAmount={this.state.paidAmount}
                dueAmount={this.state.dueAmount}
                userId={this.state.UserId}
                isActive={this.state.isActive}
                showModal={this.state.showModal}
                closeModal={this.closeModal}
                addSubBookings={this.addSubBookings}
                subBookingHandler={this.subBookingHandler}
            />)
        }

        return myModal;
    }

    // Common helper method to calculate total customer payment against a booking
    calculateCustPaymentTotals = (spotData = [], custData = []) => {
        const { totalPayableAmount } = this.state;

        const spotPaid = spotData.reduce((sum, item) => sum + (item.SpotAmount || 0), 0);
        const custPaid = custData.reduce((sum, item) => sum + (item.MRAmount || 0), 0);
        const totalPaid = spotPaid + custPaid;

        return {
            spotPaidAmount: spotPaid,
            totalPaidAmount: totalPaid,
            totalDueAmount: totalPayableAmount - totalPaid
        };
    };


    //===== Customer Payment Section =====
    //Open Customer Pay Modal
    openCustPayModal = () => {
        this.setState({
            showCustPayModal: true,
        });
    }
    //Close Customer Pay Modal
    closeCustPayModal = () => {
        let self = this;
        this.setState({ showCustPayModal: false }, () => self.resetFields());
    }
    onChangeCustPayHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    //Reset Fields
    custPayResetFields = () => {
        this.setState({
            //Customer payment details
            showCustPayModal: false,
            cpBookingId: 0,
            custPayId: 0,
            mrNo: '',
            mrDate: '',
            mrAmount: '',
            modeOfPayment: '',
            receivedBank: '',
        })
    }
    //Get all columns
    getAllCustPayDataColumns = () => {
        this.setState({
            cpColumns: [
                {
                    Header: "Action",
                    accessor: "select",
                    minWidth: 130,
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ row }) => (
                        <div className='d-flex table-action-buttons'>
                            <div
                                className="text-center table-action-button"
                                title="Edit"
                                onClick={() => this.handleCPEdit(row.original)}
                            >
                                <i className="fa-solid fa-pen-to-square"></i>
                            </div>
                            <div
                                className="text-center table-action-button"
                                title="Print"
                                onClick={() => this.handleCPPrint(row.original)}
                            >
                                <i className="fa-solid fa-print"></i>
                            </div>
                            <div
                                className="text-center table-action-button"
                                title="Remove"
                                onClick={() => this.handleCPDelete(row.original)}
                            >
                                <i className="fa-regular fa-trash-can"></i>
                            </div>
                        </div>
                    ),
                },
                { Header: "MR. No.", accessor: "MRNo", className: "text-center", disableFilters: true, },
                {
                    Header: "MR. Date",
                    accessor: "MRDate",
                    className: "text-center",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value}
                            {/* {value ? moment(value).format('YYYY-MM-DD') : ""}  */}
                        </div>
                    ),
                },
                {
                    Header: "MR. Amount",
                    accessor: "MRAmount",
                    className: "text-right",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                { Header: "Mode of Payment", accessor: "ModeOfPayment", className: "text-center", disableFilters: true, },
                {
                    Header: "Active",
                    accessor: "IsActive",
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value ? (
                                <i className="fa-regular fa-square-check"></i>
                            ) : (
                                <i className="fa-regular fa-square"></i>
                            )}
                        </div>
                    ),
                },
            ],
        })
    }
    //Search Vendor Payment data
    getAllCustPayData = (bookingId) => {
        let param = { BookingId: bookingId };
        this.setState({ isCpTableLoading: true });
        axios
            .post(ApiURL.GetPaymentToCustomer, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", {
                        position: "bottom-center",
                    });
                    return;
                }
                const custData = respData.StatusCode === 200 ? respData.DataResult : [];
                const { spData } = this.state;
                const totals = this.calculateCustPaymentTotals(spData, custData);

                this.setState(
                    {
                        cpData: custData,
                        showCustPayModal: false,
                        ...totals,
                    },
                    this.getAllCustPayDataColumns
                );

            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isCpTableLoading: false });
            });

    }
    //Save Customer Pay details
    saveCustPayment = (e) => {
        e.preventDefault();
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            let userId = userData.UserId;
            const { bookingId, custPayId, mrNo, mrDate, mrAmount, modeOfPayment, receivedBank, cpIsActive } = this.state;

            if (mrNo === '') {
                cogoToast.error("MR No. is required!", { position: "bottom-center" });
            }
            else if (mrDate === '') {
                cogoToast.error("MR date is required!", { position: "bottom-center" });
            }
            else if (mrAmount === 0) {
                cogoToast.error("MR amount must be greater than zero!", { position: "bottom-center" });
            }
            else if (modeOfPayment === '') {
                cogoToast.error("Mode of payment is required!", { position: "bottom-center" });
            }
            else if (modeOfPayment !== 'Cash' && receivedBank === '') {
                cogoToast.error("Received bank is required!", { position: "bottom-center" });
            }
            else {
                let param = {
                    CustPayId: custPayId,
                    BookingId: bookingId,
                    MRNo: mrNo,
                    MRDate: mrDate,
                    MRAmount: mrAmount,
                    ModeOfPayment: modeOfPayment,
                    ReceivedBank: receivedBank,
                    UserId: userId,
                    IsActive: cpIsActive,
                };
                console.log(param);
                axios
                    .post(ApiURL.SaveCustomerPayment, param)
                    .then((response) => {
                        let respData = response.data;
                        console.log(respData);
                        if (respData.StatusCode === 200) {
                            cogoToast.success(respData.Message, { position: "bottom-center" });
                            this.getBookingData();
                            this.custPayResetFields();
                        }
                        else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                            cogoToast.warn(respData.Message, { position: "bottom-center" });
                        }
                        else if (respData.StatusCode === 500) {
                            cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                        }
                    })
                    .catch((error) => {
                        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                    });
            }
        }
    }
    //Handle Customer Pay Edit
    handleCPEdit = (row) => {
        var self = this;
        console.log(row);
        let mrDate = moment(row.MRDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
        console.log(mrDate);
        if (row) {
            self.setState({
                custPayId: row.CustPayId,
                cpBookingId: row.BookingId,
                mrNo: row.MRNo,
                mrDate: mrDate,
                mrAmount: row.MRAmount,
                modeOfPayment: row.ModeOfPayment,
                receivedBank: row.ReceivedBank || ''
            }, () => self.openCustPayModal())
        }

    };
    //Handle Customer Pay Print
    handleCPPrint = (row) => {
        let param = { CustPayId: row.CustPayId, BookingId: row.BookingId };
        axios
            .post(ApiURL.GetMoneyReceiptReportData, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    this.setState({
                        moneyReceiptData: respData.DataResult[0],
                        showMoneyReceiptModal: true,
                    });
                }
                else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                    cogoToast.warn(respData.Message || "No data found", { position: "bottom-center" });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    closeMoneyReceiptModal = () => {
        this.setState({
            showMoneyReceiptModal: false,
            moneyReceiptData: null,
        });
    }
    handleConfirmationVoucherPrint = () => {
        const { bookingId } = this.state;
        if (!bookingId) {
            cogoToast.warn('Booking not loaded', { position: 'bottom-center' });
            return;
        }

        const param = { BookingId: bookingId };
        axios
            .post(ApiURL.GetConfirmationVoucherReportData, param)
            .then((response) => {
                const respData = response.data;
                if (respData.StatusCode === 200) {
                    const rows = respData.DataResult || [];
                    this.setState({
                        confirmationVoucherData: {
                            header: rows[0],
                            lineItems: rows,
                        },
                        showConfirmationVoucherModal: true,
                    });
                } else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                    cogoToast.warn(respData.Message || 'No data found', { position: 'bottom-center' });
                } else if (respData.StatusCode === 500) {
                    cogoToast.error('Internal Server Error ! Please Try Again.', { position: 'bottom-center' });
                }
            })
            .catch(() => {
                cogoToast.error('Request Failed! Please Try Again.', { position: 'bottom-center' });
            });
    }
    closeConfirmationVoucherModal = () => {
        this.setState({
            showConfirmationVoucherModal: false,
            confirmationVoucherData: null,
        });
    }
    handleHotelVoucherPrint = (row) => {
        const param = { SubBookingId: row.SubBookingId };
        axios
            .post(ApiURL.GetHotelBookingReportData, param)
            .then((response) => {
                const respData = response.data;
                if (respData.StatusCode === 200) {
                    this.setState({
                        hotelVoucherData: respData.DataResult[0],
                        showHotelVoucherModal: true,
                    });
                } else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                    cogoToast.warn(respData.Message || 'No data found', { position: 'bottom-center' });
                } else if (respData.StatusCode === 500) {
                    cogoToast.error('Internal Server Error ! Please Try Again.', { position: 'bottom-center' });
                }
            })
            .catch(() => {
                cogoToast.error('Request Failed! Please Try Again.', { position: 'bottom-center' });
            });
    }
    closeHotelVoucherModal = () => {
        this.setState({
            showHotelVoucherModal: false,
            hotelVoucherData: null,
        });
    }
    //Handle Customer Pay Delete
    handleCPDelete = (row) => {
        var self = this;
        let param = { CustPayId: row.CustPayId };
        console.log(param);
        axios
            .post(ApiURL.DeleteCustomerPayment, param)
            .then((response) => {
                let respData = response.data;
                console.log(respData);
                if (respData.StatusCode === 200) {
                    cogoToast.success("Customer payment deleted !", { position: "bottom-center" });
                    this.getAllCustPayData(this.state.bookingId);
                }
                else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                    cogoToast.warn(respData.Message, { position: "bottom-center" });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }


    //===== Vendor Payment Section =====
    //Open Vendor Pay Modal
    openVendorPayModal = () => {
        this.setState({
            showVendorPayModal: true,
        });
    }
    //Close Customer Pay Modal
    closeVendorPayModal = () => {
        this.vendorPayResetFields();
    }
    //Save Vendor Payment
    saveVendorPayment = (e) => {
        e.preventDefault();
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            let userId = userData.UserId;
            const { vpId, vpSubBookingId, vpTravelCircuitId, vpLocationId, vpSubBookingType, vpVendorId,
                vpPaymentDate, vpPaidAmount, vpBankName, vpComment, vpIsActive } = this.state;
            const vendorCategoryId = vpSubBookingType === "Hotel" ? 1 : vpSubBookingType === "Car" ? 2 : 3;

            if (vpPaymentDate === '') {
                cogoToast.error("Payment date is required!", { position: "bottom-center" });
            }
            else if (vpPaidAmount === '' || vpPaidAmount === 0) {
                cogoToast.error("Paid amount is required!", { position: "bottom-center" });
            }
            else if (vpBankName === '') {
                cogoToast.error("Bank Name is required!", { position: "bottom-center" });
            }
            else {
                let param = {
                    VendorPayId: vpId,
                    SubBookingId: vpSubBookingId,
                    TravelCircuitId: vpTravelCircuitId,
                    LocationId: vpLocationId,
                    VendorCategoryId: vendorCategoryId,
                    VendorId: vpVendorId,
                    PaymentDate: vpPaymentDate,
                    PaidAmount: vpPaidAmount,
                    BankName: vpBankName,
                    Comment: vpComment,
                    UserId: userId,
                    IsActive: vpIsActive,
                }
                console.log(param);
                axios
                    .post(ApiURL.SaveVendorPayment, param)
                    .then((response) => {
                        let respData = response.data;
                        if (respData.StatusCode === 200) {
                            cogoToast.success(respData.Message, { position: "bottom-center" });
                            this.getBookingData();
                            this.vendorPayResetFields();
                        }
                        else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                            cogoToast.warn(respData.Message, { position: "bottom-center" });
                        }
                        else if (respData.StatusCode === 500) {
                            cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                        }
                    })
                    .catch((error) => {
                        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                    });
            }
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
    }
    //OnChangeHandler for Vendor Payment
    onChangeVendorPayHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    //Reset Fields
    vendorPayResetFields = () => {
        this.setState({
            //Vendor payment details
            showVendorPayModal: false,
            vpId: 0,
            vpSubBookingId: 0,
            vpSubBookingNo: '',
            vpTravelCircuitId: 0,
            vpLocationId: 0,
            vpLocationName: '',
            vpSubBookingType: '',
            vpVendorId: 0,
            vpVendorName: '',
            vpPaymentDate: '',
            vpPaidAmount: '',
            vpBankName: '',
            vpComment: ''
        })
    }
    //Get all columns
    getAllVendorPayDataColumns = () => {
        this.setState({
            vpColumns: [
                {
                    Header: "Action",
                    accessor: "select",
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ row }) => (
                        <div className='d-flex table-action-buttons'>
                            <div
                                className="text-center table-action-button"
                                title="Edit"
                                onClick={() => this.handleVPEdit(row.original)}
                            >
                                <i className="fa-solid fa-pen-to-square"></i>
                            </div>
                            <div
                                className="text-center table-action-button"
                                title="Remove"
                                onClick={() => this.handleVPDelete(row.original)}
                            >
                                <i className="fa-regular fa-trash-can"></i>
                            </div>
                        </div>
                    ),
                },
                {
                    Header: "Payment Date",
                    accessor: "PaymentDate",
                    className: "text-center",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value ? moment(value).format('DD-MM-YYYY') : ""} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                {
                    Header: "Paid Amount",
                    accessor: "PaidAmount",
                    className: "text-right",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                { Header: "Bank Name", accessor: "BankName", className: "text-center", disableFilters: true, },
            ],
        })
    }
    //Search Vendor Payment data
    getAllVendorPayData = (subBookingId) => {
        var self = this;
        let param = { SubBookingId: subBookingId };
        this.setState({ isVpTableLoading: true });
        axios
            .post(ApiURL.GetPaymentToVendor, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    const totalPaid = dataResult.reduce((sum, item) => sum + item.PaidAmount, 0);
                    console.log(dataResult);
                    this.setState({
                        vpData: dataResult,
                        //totalPaidAmount: totalPaid,
                        //showVendorPayModal: false
                    }, () => self.getAllVendorPayDataColumns());
                }
                if (respData.StatusCode === 404) {
                    this.setState({ vpData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isVpTableLoading: false });
            });

    }
    //Handle Vendor Pay Edit
    handleVPEdit = (row) => {
        //console.log(row);
        if (row) {
            this.setState({
                vpId: row.VendorPayId,
                vpSubBookingId: row.SubBookingId,
                vpSubBookingNo: row.SubBookingNo,
                vpTravelCircuitId: row.TravelCircuitId,
                vpLocationId: row.LocationId,
                vpLocationName: row.LocationName,
                vpVendorCategoryId: row.VendorCategoryId,
                vpVendorId: row.VendorId,
                vpVendorName: row.VendorName,
                vpPaymentDate: row.PaymentDate,
                vpPaidAmount: row.PaidAmount,
                vpBankName: row.BankName,
                vpComment: row.Comment,
                vpDueAmount: row.DueAmount
            })
        }

    };
    //Handle Vendor Pay Delete
    handleVPDelete = (row) => {
        var self = this;
        let param = { VendorPayId: row.VendorPayId };
        axios
            .post(ApiURL.DeleteVendorPayment, param)
            .then((response) => {
                let respData = response.data;
                //console.log(respData);
                if (respData.StatusCode === 200) {
                    cogoToast.success(respData.Message, { position: "bottom-center" });
                    //self.getAllVendorPayData(self.state.subBookingId);
                    self.getBookingData();
                    self.vendorPayResetFields();
                }
                else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                    cogoToast.warn(respData.Message, { position: "bottom-center" });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }

    //===== Spot Payment Section =====    
    //Open Spot Pay Modal
    openSpotPayModal = () => {
        var self = this;
        self.setState({
            showSpotPayModal: true,
        }, () => {
            self.getAllSpotVendorData(this.state.bookingId);
            self.getAllSpotBookingData(this.state.bookingId, 0);
        });
    }
    //Close Spot Pay Modal
    closeSpotPayModal = () => {
        this.spotPayResetFields();
        this.setState({ showSpotPayModal: false })
    }
    //Get all Spot Vendor data by BookingId
    getAllSpotVendorData = (bookingId) => {
        let param = { BookingId: bookingId };
        axios
            .post(ApiURL.GetAllSpotBookingVendor, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ spVendorData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ spVendorData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Save Spot Payment
    saveSpotPayment = (e) => {
        e.preventDefault();
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            let userId = userData.UserId;
            const { spId, bookingId, spTravelCircuitId, spLocationId, spVendorCategoryId, spVendorId,
                spPaymentDate, spSpotAmount, spIsAmountPaid, spComment, spIsActive, dueAmount } = this.state;
            //const vendorCategoryId = spSubBookingType === "Hotel" ? 1 : spSubBookingType === "Car" ? 2 : 3;
            if (spLocationId === '') {
                cogoToast.error("Location is required!", { position: "bottom-center" });
            }
            if (spVendorCategoryId === '') {
                cogoToast.error("Vendor Category is required!", { position: "bottom-center" });
            }
            if (spVendorId === '') {
                cogoToast.error("Vendor is required!", { position: "bottom-center" });
            }
            if (spPaymentDate === '') {
                cogoToast.error("Payment date is required!", { position: "bottom-center" });
            }
            else if (spSpotAmount === '' || spSpotAmount === 0) {
                cogoToast.error("Spot amount is required!", { position: "bottom-center" });
            }
            else {
                let param = {
                    SpotBookingId: spId,
                    BookingId: bookingId,
                    TravelCircuitId: spTravelCircuitId,
                    LocationId: parseInt(spLocationId),
                    VendorCategoryId: parseInt(spVendorCategoryId),
                    VendorId: parseInt(spVendorId),
                    PaymentDate: spPaymentDate,
                    SpotAmount: parseFloat(spSpotAmount),
                    IsAmountPaid: spIsAmountPaid,
                    Comment: spComment,
                    UserId: userId,
                    IsActive: spIsActive,
                }
                console.log(param);
                axios
                    .post(ApiURL.SaveSpotPayment, param)
                    .then((response) => {
                        let respData = response.data;
                        if (respData.StatusCode === 200) {
                            cogoToast.success(respData.Message, { position: "bottom-center" });
                            this.getAllSpotBookingData(this.state.bookingId, 0);
                            this.spotPayResetFields();
                        }
                        else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                            cogoToast.warn(respData.Message, { position: "bottom-center" });
                        }
                        else if (respData.StatusCode === 500) {
                            cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                        }
                    })
                    .catch((error) => {
                        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                    });
            }
        }
        else {
            let winlocation = window.location.pathname;
            LocalStorageHelper.SetLastRedirectPath(winlocation);
            this.setState({ RedirectToLogin: true })
        }
    }
    //OnChangeHandler for Spot Payment
    onChangeSpotPayHandler = (e) => {
        if (e.target.name === "spVendorId") {
            let { spVendorId, spVendorData } = this.state;
            spVendorId = e.target.value;
            let selectedVendor = spVendorData.find(x => x.VendorId == spVendorId);
            //console.log(selectedVendor);
            if (selectedVendor !== typeof (undefined)) {
                this.setState({
                    spVendorId: selectedVendor.VendorId,
                    spTravelCircuitId: selectedVendor.TravelCircuitId,
                    spTravelCircuitName: selectedVendor.TravelCircuitName,
                    spLocationId: selectedVendor.LocationId,
                    spLocationName: selectedVendor.LocationName,
                    spVendorCategoryId: selectedVendor.VendorCategoryId,
                    spVendorCategoryName: selectedVendor.VendorCategoryName,
                });
            }
        }

        if (e.target.name === "spIsAmountPaid") {
            console.log(e.target.checked);
            this.setState({
                [e.target.name]: e.target.checked
            });
        }
        else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }
    //Reset Fields
    spotPayResetFields = () => {
        var self = this;
        self.setState({
            //Spot payment details
            spVendorData: [],
            spId: 0,
            spTravelCircuitId: 0,
            spTravelCircuitName: '',
            spLocationId: 0,
            spLocationName: '',
            spVendorCategoryId: 0,
            spVendorCategoryName: '',
            spVendorId: 0,
            spVendorName: '',
            spPaymentDate: '',
            spSpotAmount: '',
            spComment: '',
            spIsAmountPaid: false,
        }, () => {
            self.getAllSpotVendorData(self.state.bookingId);
        })
    }
    //Get all columns
    getAllSpotPayDataColumns = () => {
        this.setState({
            spColumns: [
                {
                    Header: "Action",
                    accessor: "select",
                    disableSortBy: true,
                    disableFilters: true,
                    Cell: ({ row }) => (
                        <div className='d-flex table-action-buttons'>
                            <div
                                className="text-center table-action-button"
                                title="Edit"
                                onClick={() => this.handleSPEdit(row.original)}
                            >
                                <i className="fa-solid fa-pen-to-square"></i>
                            </div>
                            <div
                                className="text-center table-action-button"
                                title="Remove"
                                onClick={() => this.handleSPDelete(row.original)}
                            >
                                <i className="fa-regular fa-trash-can"></i>
                            </div>
                        </div>
                    ),
                },
                /* { Header: "Travel Circuit", accessor: "TravelCircuitName", className: "text-center", disableFilters: true, }, */
                { Header: "LocationName", accessor: "LocationName", className: "text-center", disableFilters: true, },
                { Header: "Vendor Category", accessor: "VendorCategoryName", className: "text-center", disableFilters: true, },
                { Header: "VendorName", accessor: "VendorName", className: "text-center", disableFilters: true, },
                {
                    Header: "Payment Date",
                    accessor: "PaymentDate",
                    className: "text-center",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-center">
                            {value ? moment(value).format('DD-MM-YYYY') : ""} {/* Format to 2 decimal places */}
                        </div>
                    ),
                },
                {
                    Header: "Spot Amount",
                    accessor: "SpotAmount",
                    className: "text-right",
                    disableFilters: true,
                    Cell: ({ value }) => (
                        <div className="text-right">
                            {value ? value.toFixed(2) : "0.00"} {/* Format to 2 decimal places */}
                        </div>
                    ),
                }
            ],
        })
    }
    //Search Spot Payment data
    getAllSpotBookingData = (bookingId, spotBookingId) => {
        let param = { BookingId: bookingId, SpotBookingId: spotBookingId };
        this.setState({ isSpTableLoading: true });
        axios
            .post(ApiURL.GetAllSpotPayment, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", {
                        position: "bottom-center",
                    });
                    return;
                }
                const spotData = respData.StatusCode === 200 ? respData.DataResult : [];
                const { cpData } = this.state;
                const totals = this.calculateCustPaymentTotals(spotData, cpData);
                this.setState(
                    {
                        spData: spotData,
                        ...totals,
                    },
                    () => {
                        this.getAllSpotPayDataColumns();
                        this.calculatePackageSummary();
                    }
                );
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isSpTableLoading: false });
            });
    }
    //Handle Spot Pay Edit
    handleSPEdit = (row) => {
        console.log(row);
        if (row) {
            let locationId = row.LocationId;
            let vendorCategoryId = row.VendorCategoryId;
            this.getAllSpotVendorData(this.state.bookingId);
            const formattedPaymentDate = dayjs(row.PaymentDate).format("YYYY-MM-DD");
            this.setState({
                spId: row.SpotBookingId,
                spTravelCircuitId: row.TravelCircuitId,
                spTravelCircuitName: row.TravelCircuitName,
                spLocationId: row.LocationId,
                spLocationName: row.LocationName,
                spVendorCategoryId: row.VendorCategoryId,
                spVendorCategoryName: row.VendorCategoryName,
                spVendorId: row.VendorId,
                spPaymentDate: formattedPaymentDate,
                spSpotAmount: row.SpotAmount,
                spIsAmountPaid: row.IsAmountPaid,
                spComment: row.Comment,
            })
        }

    };
    //Handle Spot Pay Delete
    handleSPDelete = (row) => {
        //var self = this;
        let param = { SpotBookingId: row.SpotBookingId };
        axios
            .post(ApiURL.DeleteSpotPayment, param)
            .then((response) => {
                let respData = response.data;
                //console.log(respData);
                if (respData.StatusCode === 200) {
                    cogoToast.success(respData.Message, { position: "bottom-center" });
                    this.getAllSpotBookingData(this.state.bookingId, 0);
                    this.spotPayResetFields();
                }
                else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                    cogoToast.warn(respData.Message, { position: "bottom-center" });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }

    render() {
        const { activeTab, subBookings, columns, TCData, locationData, bookingTypeData, bookingNo, mrNo, mrDate, mrAmount,
            modeOfPayment, receivedBank, states, placeOfSupplies, specialists,
            packageSoldAmount, spotPaidAmount, packageCostAmount, taxableAmount, cgstPercent, cgstAmount, sgstPercent,
            sgstAmount, igstPercent, igstAmount, tcsReceived, tcsPercent, tcsAmount, packageProfitAfterTaxAmount,
            ticketSoldAmount, ticketCostAmount, ticketProfitAmount, ticketProfitAfterTaxAmount, taxPercentOnTicketProfit,
            taxOnTicketProfitAmount, grandTotalSaleAmount, grandTotalCostAmount, totalTaxAmount, netProfit, profitMarginPercent
        } = this.state;

        return (
            <>
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Manage Booking" />
                        </div>
                        <div className="col-md-3 pt-1">
                            <div className="d-flex justify-content-between align-items-center">
                                <select
                                    name="bookingStatus"
                                    className="form-control-sm border border-primary form-select w-50"
                                    value={this.state.bookingStatus}
                                    onChange={this.onBookingStatusChangeHandler}
                                >
                                    <option value="Active">Active</option>
                                    <option value="Postponed">Postponed</option>
                                    <option value="Cancelled">Cancelled</option>
                                </select>

                                <button
                                    className="btn btn-outline-dark btn-sm px-3"
                                    title="Refresh"
                                    onClick={this.handleReload}
                                >
                                    <i className="fa-solid fa-arrows-rotate"></i> Refresh
                                </button>

                                <button
                                    className="btn btn-outline-primary btn-sm px-3 cursor-pointer"
                                    title="Save"
                                    onClick={this.updateBooking}
                                >
                                    <i className="fa-solid fa-save"></i> Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid py-4 mt-115">
                    <div className="card border border-primary mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Booking No.</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control-sm border border-primary w-100" name="bookingNo" value={this.state.bookingNo} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Booking Date</label>
                                        <div className="col-md-8">
                                            <input type="date" className="form-control-sm border border-primary w-100" name="bookingDate" value={this.state.bookingDate} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Travel Circuit</label>
                                        <div className="col-md-8">
                                            <input type="text" className="form-control-sm border border-primary w-100" name="travelDestination" value={this.state.travelDestination} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">First Name</label>
                                        <div className="col-md-8">
                                            <input type="text" name="firstName" className="form-control-sm border border-primary w-100" value={this.state.firstName} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Last Name</label>
                                        <div className="col-md-8">
                                            <input type="text" name="lastName" className="form-control-sm border border-primary w-100" value={this.state.lastName} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Mobile No</label>
                                        <div className="col-md-8">
                                            <input type="text" name="mobile" className="form-control-sm border border-primary w-100" value={this.state.mobile} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Email</label>
                                        <div className="col-md-8">
                                            <input type="email" name="email" className="form-control-sm border border-primary w-100" value={this.state.email} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">State <span className='text-danger'>*</span></label>
                                        <div className="col-md-8">
                                            <select name="stateId" className="form-control-sm border border-primary form-select w-100" value={this.state.stateId} onChange={this.onChangeHandler}>
                                                <option value="">-- Select --</option>
                                                {states.map((item, index) => (
                                                    <option key={index} value={item.StateId}>
                                                        {`${item.StateName} [${item.StateCode}]`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Place of Supply <span className='text-danger'>*</span></label>
                                        <div className="col-md-8">
                                            <select name="placeOfSupplyId"
                                                className="form-control-sm border border-primary form-select w-100"
                                                disabled={this.state.bookingTypeId == 1}
                                                value={this.state.placeOfSupplyId}
                                                onChange={this.onChangeHandler}>
                                                <option value="">-- Select --</option>
                                                {placeOfSupplies.map((item, index) => (
                                                    <option key={index} value={item.PlaceOfSupplyId}>
                                                        {`${item.PlaceOfSupplyName} [${item.PlaceOfSupplyCode}]`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="form-group row">
                                        <label className="col-md-2 col-form-label-sm border border-primary bg-primary-subtle">Address</label>
                                        <div className="col-md-10">
                                            <input type="text" name="address" className="form-control-sm border border-primary w-100" value={this.state.address} onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Trip Category</label>
                                        <div className="col-md-8">
                                            <select name="placeOfSupplyId" className="form-control-sm border border-primary form-select w-100" value={this.state.tripCategory} disabled>
                                                <option value="Domestic">Domestic</option>
                                                <option value="International">International</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Specialist <span className='text-danger'>*</span></label>
                                        <div className="col-md-8">
                                            <select name="specialistId" className="form-control-sm border border-primary form-select w-100" value={this.state.specialistId} onChange={this.onChangeHandler}>
                                                <option value="">-- Select --</option>
                                                {specialists.map((item, index) => (
                                                    <option key={index} value={item.SpecialistId}>
                                                        {item.SpecialistName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">
                                            GSTIN {this.state.bookingTypeId == 1 && <span className='text-danger'>*</span>}
                                        </label>
                                        <div className="col-md-8">
                                            <input type="text" name="gstin" className="form-control-sm border border-primary w-100" value={this.state.gstin} onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">
                                            PAN {this.state.bookingTypeId == 1 && <span className='text-danger'>*</span>}
                                        </label>
                                        <div className="col-md-8">
                                            <input type="text" name="pan" className="form-control-sm border border-primary w-100" value={this.state.pan} onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Payable Amount</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control-sm border border-primary w-100 text-right" name="totalPayableAmount" value={this.state.totalPayableAmount.toFixed(2)} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Paid Amount</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control-sm border border-primary w-100 text-right" name="totalPaidAmount" value={this.state.totalPaidAmount.toFixed(2)} disabled />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group row">
                                        <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Due Amount</label>
                                        <div className="col-md-8">
                                            <input type="number" className="form-control-sm border border-primary w-100 text-right" name="totalDueAmount" value={this.state.totalDueAmount.toFixed(2)} disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {
                                    this.state.bookingStatus === 'Postponed' &&
                                    <>
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">CN Number</label>
                                                <div className="col-md-8">
                                                    <input type="text" name="cnNumber" className="form-control-sm border border-primary w-100" value={this.state.cnNumber} onChange={this.onChangeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">CN Date</label>
                                                <div className="col-md-8">
                                                    <input type="date" name="cnDate" className="form-control-sm border border-primary w-100" value={this.state.cnDate} onChange={this.onChangeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">CN Amount</label>
                                                <div className="col-md-8">
                                                    <input type="number"
                                                        name="cnAmount"
                                                        className="form-control-sm border border-4 border-primary text-right w-100"
                                                        value={this.state.cnAmount}
                                                        onChange={this.onChangeHandler}
                                                        onBlur={this.onBlurHandler}
                                                        autoComplete="off"
                                                    /* style={{ backgroundColor: '#cfe2ff', color: '#000' }} */
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className="row">
                                {
                                    this.state.bookingStatus === 'Cancelled' &&
                                    <>
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Refund Date</label>
                                                <div className="col-md-8">
                                                    <input type="date" name="refundDate" className="form-control-sm border border-primary w-100" value={this.state.refundDate} onChange={this.onChangeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Refund Amount</label>
                                                <div className="col-md-8">
                                                    <input type="number"
                                                        name="refundAmount"
                                                        className="form-control-sm border border-4 border-primary text-right w-100"
                                                        value={this.state.refundAmount}
                                                        onChange={this.onChangeHandler}
                                                        onBlur={this.onBlurHandler}
                                                        autoComplete="off"
                                                    /* style={{ backgroundColor: '#cfe2ff', color: '#000' }} */
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Refund Bank</label>
                                                <div className="col-md-8">
                                                    <input type="text" name="refundBank" className="form-control-sm border border-primary w-100" value={this.state.refundBank} onChange={this.onChangeHandler} />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            <div className="row">
                                {
                                    this.state.bookingStatus === 'Cancelled' &&
                                    <div className="col-md-4">
                                        <div className="form-group row">
                                            <label className="col-md-4 col-form-label-sm border border-primary bg-primary-subtle">Bank Ref. No.</label>
                                            <div className="col-md-8">
                                                <input type="text" name="bankRefNo" className="form-control-sm border border-primary w-100" value={this.state.bankRefNo} onChange={this.onChangeHandler} />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>
                    </div>

                    {/* <div className="alert alert-danger border-start border-primary border-2 fs-6 my h-100 overflow-auto">
                        <i className="fa fa-info-circle px-2 fs-6" aria-hidden="true"></i>
                        Error! Update faild. Please correct the error(s) and try again.
                        <ul className='fs-6'>
                            <li>Online fare is currently not available for this postcode at this moment.</li>
                            <li>Online fare is currently not available for this postcode at this moment.</li>
                            <li>Online fare is currently not available for this postcode at this moment.</li>
                            <li>Online fare is currently not available for this postcode at this moment.</li>
                            <li>Online fare is currently not available for this postcode at this moment.</li>                            
                        </ul>
                    </div> */}

                    <ul className="nav nav-tabs" role="tablist">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'bookingInfo' ? 'active' : ''}`}
                                onClick={() => this.handleTabChange('bookingInfo')}
                            >
                                Booking Details
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'subBookingInfo' ? 'active' : ''}`}
                                onClick={() => this.handleTabChange('subBookingInfo')}
                            >
                                Sub Booking Details
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'customerPayments' ? 'active' : ''}`}
                                onClick={() => this.handleTabChange('customerPayments')}
                            >
                                Customer Payments
                            </button>
                        </li>
                    </ul>

                    <div className="tab-content border border-primary mt-3">
                        {activeTab === 'bookingInfo' && (
                            <div className="tab-pane fade show active">
                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-4">
                                            <label className="form-label">Travel Circuit <span className='text-danger'>*</span></label>
                                            <select name="tcId" className="form-control-sm border border-primary form-select w-100" value={this.state.tcId} onChange={this.onChangeHandler}>
                                                <option value="">-- Select --</option>
                                                {TCData.map((item, index) => (
                                                    <option key={index} value={item.TravelCircuitId}>
                                                        {item.TravelCircuitName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Booking Type <span className='text-danger'>*</span></label>
                                            <select name="bookingTypeId" className="form-control-sm border border-primary form-select w-100" value={this.state.bookingTypeId} onChange={this.onChangeHandler}>
                                                <option value="">-- Select --</option>
                                                {bookingTypeData.map((item, index) => (
                                                    <option key={index} value={item.BookingTypeId}>
                                                        {item.BookingType}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Booking Date <span className='text-danger'>*</span></label>
                                            <input type="date" name="bookingDate" className="form-control-sm border border-primary w-100" value={this.state.bookingDate} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Start Date <span className='text-danger'>*</span></label>
                                            <input type="date" name="journeyStartDate" className="form-control-sm border border-primary w-100" value={this.state.journeyStartDate} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">End Date <span className='text-danger'>*</span></label>
                                            <input type="date" name="journeyEndDate" className="form-control-sm border border-primary w-100" value={this.state.journeyEndDate} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Journey Start Point <span className='text-danger'>*</span></label>
                                            <input type="text" name="journeyStartPoint" className="form-control-sm border border-primary w-100" value={this.state.journeyStartPoint} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label">Journey End Point <span className='text-danger'>*</span></label>
                                            <input type="text" name="journeyEndPoint" className="form-control-sm border border-primary w-100" value={this.state.journeyEndPoint} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Ticket Booked ? <span className='text-danger'>*</span></label>
                                            <select className="form-control-sm border border-primary form-select w-100" name="ticketBooked" value={this.state.ticketBooked} onChange={this.onChangeHandler}>
                                                <option value="">-- Select --</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                                <option value="Will do soon">Will do soon</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">No. of Guest <span className='text-danger'>*</span></label>
                                            <input type="number" name="noOfGuests" className="form-control-sm border border-primary w-100" value={this.state.noOfGuests} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">No of Adults </label>
                                            <input type="number" name="noOfAdults" className="form-control-sm border border-primary w-100" value={this.state.noOfAdults} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">No of Children</label>
                                            <input type="number" name="noOfChildrens" className="form-control-sm border border-primary w-100" value={this.state.noOfChildrens} onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}

                        {activeTab === 'subBookingInfo' && (
                            <div className="tab-pane fade show active">
                                <div className="container-fluid">
                                    <div className='row mb-3'>
                                        <div className="input-group col-md-4 ml-1">
                                            <select
                                                className="form-select form-select-sm"
                                                name="subBookingType"
                                                value={this.state.subBookingType}
                                                onChange={this.subBookingOnChangeHandler}
                                            >
                                                <option value="">-- Select --</option>
                                                <option value="Hotel">Hotel</option>
                                                <option value="Car">Car</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            <div className="input-group-append mx-1">
                                                <button className="btn btn-outline-primary btn-sm" title="Add Sub-Booking" onClick={this.handleAddNew}>
                                                    <i className="fas fa-plus"></i> Add Sub-Booking
                                                </button>
                                            </div>
                                            <div className="input-group-append mx-1">
                                                <button
                                                    className="btn btn-outline-info btn-sm px-3"
                                                    title="Print Confirmation Voucher"
                                                    onClick={this.handleConfirmationVoucherPrint}
                                                >
                                                    <i className="fa-solid fa-print"></i> Confirmation Voucher
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TableComponent columns={columns} data={subBookings} isLoading={this.state.isSubBookingTableLoading} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <table className="table table-sm">
                                                <tbody>
                                                    <tr>
                                                        <th colSpan={3}>Land Package SP</th>
                                                        <td className='text-right'>
                                                            <input type="number"
                                                                name="packageSoldAmount"
                                                                className="form-control-sm border border-4 border-dark text-right"
                                                                value={packageSoldAmount}
                                                                onChange={this.onChangeHandler}
                                                                onBlur={this.onBlurHandler}
                                                                autoComplete="off"
                                                                style={{ backgroundColor: '#cfe2ff', color: '#000' }}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Spot Paid Amount</th>
                                                        <td className='text-right'>
                                                            <input type="button" value="Add / Edit" onClick={this.openSpotPayModal}></input>&nbsp;
                                                            <input type="number"
                                                                name="spotPaidAmount"
                                                                className="form-control-sm border border-4 border-dark text-right"
                                                                value={spotPaidAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Land Package CP</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="packageCostAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={packageCostAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Taxable Amount</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="taxableAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={taxableAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>CGST ({cgstPercent.toFixed(2)}%) Amount</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="cgstAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={cgstAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>SGST ({sgstPercent.toFixed(2)}%) Amount</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="sgstAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={sgstAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>IGST ({igstPercent.toFixed(2)}%) Amount</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="igstAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={igstAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>TCS Received (Yes/No)?</th>
                                                        <td className='text-right'>
                                                            <div className="form-check form-switch mt-1">
                                                                <input type="checkbox"
                                                                    name="tcsReceived"
                                                                    className="form-check-input"
                                                                    checked={tcsReceived}
                                                                    onChange={this.onRadioChangeHandler}
                                                                    style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                                />
                                                            </div>
                                                        </td>
                                                        <th className='text-right'>TCS ({tcsPercent.toFixed(2)}%) Amount</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="tcsAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={tcsAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Land Package Profit after Tax</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="packageProfitAfterTaxAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={packageProfitAfterTaxAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr><td colSpan={4}>&nbsp;</td></tr>
                                                    <tr>
                                                        <th>Air/Train Ticket SP</th>
                                                        <td className='text-right'>
                                                            <input type="number"
                                                                name="ticketSoldAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={ticketSoldAmount}
                                                                onChange={this.onChangeHandler}
                                                                onBlur={this.onBlurHandler}
                                                                autoComplete="off"
                                                                style={{ backgroundColor: '#cfe2ff', color: '#000' }}
                                                            />
                                                        </td>
                                                        <th className='text-right'>Air/Train ticket Profit</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="ticketProfitAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={ticketProfitAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Air/Train Ticket CP</th>
                                                        <td className='text-right'>
                                                            <input type="number"
                                                                name="ticketCostAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={ticketCostAmount}
                                                                onChange={this.onChangeHandler}
                                                                onBlur={this.onBlurHandler}
                                                                autoComplete="off"
                                                                style={{ backgroundColor: '#cfe2ff', color: '#000' }}
                                                            />
                                                        </td>
                                                        <th className='text-right'>Ticket Profit after Tax</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="ticketProfitAfterTaxAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={ticketProfitAfterTaxAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={2}>&nbsp;</th>
                                                        <th className='text-right'>Tax on Ticket Profit ({taxPercentOnTicketProfit}%)</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="taxOnTicketProfitAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={taxOnTicketProfitAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr><td colSpan={4}>&nbsp;</td></tr>
                                                    <tr>
                                                        <th colSpan={3}>Grand Total Sale Price</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="grandTotalSaleAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={grandTotalSaleAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Grand Total Cost Price</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="grandTotalCostAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={grandTotalCostAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Total Tax Amount</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="totalTaxAmount"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={totalTaxAmount.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Net Profit Amount</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="netProfit"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={netProfit.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th colSpan={3}>Profit Mergin (%)</th>
                                                        <td className='text-right'>
                                                            <input type="text"
                                                                name="profitMarginPercent"
                                                                className="form-control-sm border border-primary text-right"
                                                                value={profitMarginPercent.toFixed(2)}
                                                                disabled
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'customerPayments' && (
                            <div className="tab-pane fade show active">
                                <div className="container-fluid">
                                    <div className='row mb-3'>
                                        <div className="input-group col-md-4 ml-1">
                                            <div className="input-group-append">
                                                {
                                                    this.state.totalDueAmount > 0 ?
                                                        <button className="btn btn-outline-danger btn-sm" title="Add Sub-Booking" onClick={this.openCustPayModal}>
                                                            <i className="fas fa-plus"></i> Add Customer Payment
                                                        </button>
                                                        :
                                                        <button className="btn btn-outline-success btn-sm disabled" title="Add Sub-Booking">
                                                            <i className="fas fa-plus"></i> Add Customer Payment
                                                        </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <TableComponent
                                                columns={this.state.cpColumns}
                                                data={this.state.cpData}
                                                isLoading={this.state.isCpTableLoading}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                </div >

                {/* <!-- Customer payment modal section--> */}
                <div className={this.state.showCustPayModal === true ? "modal show-modal  modalWrapper" : "modal"} >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    Manage Customer Payment
                                </h3>
                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeCustPayModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <form>
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <label className="form-label">Booking No. <span className='text-danger'>*</span></label>
                                                <input type="text" name="bookingNo" className="form-control-sm border border-primary w-100" value={bookingNo} disabled />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">MR No.</label>
                                                <input type="text" name="mrNo" className="form-control-sm border border-primary w-100" value={mrNo} onChange={this.onChangeCustPayHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">MR Date</label>
                                                <input type="date" name="mrDate" className="form-control-sm border border-primary w-100" value={mrDate} onChange={this.onChangeCustPayHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">MR Amount</label>
                                                <input type="number" name="mrAmount" className="form-control-sm border border-primary w-100" value={mrAmount} onChange={this.onChangeCustPayHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Mode of Payment</label>
                                                <select name="modeOfPayment"
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    value={modeOfPayment}
                                                    onChange={this.onChangeCustPayHandler}
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="Cash">Cash</option>
                                                    <option value="Cheque">Cheque</option>
                                                    <option value="NEFT">NEFT</option>
                                                    <option value="RTGS">RTGS</option>
                                                    <option value="UPI">UPI</option>
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">
                                                    Received Bank
                                                    {modeOfPayment !== 'Cash' && modeOfPayment !== '' && (
                                                        <span className='text-danger'>*</span>
                                                    )}
                                                </label>
                                                <select name="receivedBank"
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    value={receivedBank}
                                                    onChange={this.onChangeCustPayHandler}
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="Axis">Axis</option>
                                                    <option value="Bandhan">Bandhan</option>
                                                    <option value="BOI">BOI</option>
                                                    <option value="HDFC">HDFC</option>
                                                    <option value="ICICI">ICICI</option>
                                                    <option value="IDFC">IDFC</option>
                                                    <option value="IDFC">Indusind</option>
                                                    <option value="PNB">PNB</option>
                                                    <option value="SBI">SBI</option>
                                                    <option value="TDS">TDS</option>
                                                </select>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button className="btn btn-success button-box-shadow" onClick={this.saveCustPayment}>
                                    <i className="fa-solid fa-circle-check"></i> Save
                                </button>

                                <button className="btn btn-secondary button-box-shadow" onClick={this.closeCustPayModal}>
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div >
                {/* <!-- Customer payment modal section--> */}


                {/* <!-- Vendor payment modal section --> */}
                <div className={this.state.showVendorPayModal === true ? "modal show-modal  modalWrapper" : "modal"}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    {
                                        this.state.vpDueAmount == 0 ?
                                            <i className="fa-solid fa-circle-check text-success mr-1"></i>
                                            :
                                            <i className="fa-solid fa-circle-xmark text-danger mr-1"></i>
                                    }
                                    Manage Vendor Payment
                                </h3>

                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeVendorPayModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <form>
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <label className="form-label">Sub-Booking No.</label>
                                                <input type="text" name="SubBookingNo" className="form-control-sm border border-primary w-100" value={this.state.vpSubBookingNo} disabled />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Travel Circuit</label>
                                                <select name="tcId" className="form-control-sm border border-primary form-select w-100" value={this.state.vpTravelCircuitId} disabled>
                                                    <option value="">-- Select --</option>
                                                    {TCData.map((item, index) => (
                                                        <option key={index} value={item.TravelCircuitId}>
                                                            {item.TravelCircuitName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Location</label>
                                                <input type="text" name="locationName" className="form-control-sm border border-primary w-100" value={this.state.vpLocationName} disabled />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Vendor Category</label>
                                                <input type="text" name="subBookingType" className="form-control-sm border border-primary w-100" value={this.state.vpSubBookingType} disabled />
                                            </div>
                                            <div className="col-md-8">
                                                <label className="form-label">Vendor Name</label>
                                                <input type="text" name="vendorName" className="form-control-sm border border-primary w-100" value={this.state.vpVendorName} disabled />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Payment Date <span className='text-danger'>*</span></label>
                                                <input type="date" name="vpPaymentDate" className="form-control-sm border border-primary w-100" value={this.state.vpPaymentDate} onChange={this.onChangeVendorPayHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Amount <span className='text-danger'>*</span></label>
                                                <input type="number" name="vpPaidAmount" className="form-control-sm border border-primary w-100" value={this.state.vpPaidAmount} onChange={this.onChangeVendorPayHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Bank Name <span className='text-danger'>*</span></label>
                                                <select name="vpBankName"
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    value={this.state.vpBankName}
                                                    onChange={this.onChangeVendorPayHandler}
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="Axis">Axis</option>
                                                    <option value="Bandhan">Bandhan</option>
                                                    <option value="BOI">BOI</option>
                                                    <option value="HDFC">HDFC</option>
                                                    <option value="ICICI">ICICI</option>
                                                    <option value="IDFC">IDFC</option>
                                                    <option value="PNB">PNB</option>
                                                    <option value="SBI">SBI</option>
                                                    <option value="TDS">TDS</option>
                                                </select>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="form-label">Comments</label>
                                                <textarea
                                                    name="vpComment"
                                                    className="form-control border border-secondary"
                                                    rows="2"
                                                    value={this.state.vpComment}
                                                    onChange={this.onChangeVendorPayHandler}></textarea>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-sm-12">
                                        {
                                            this.state.vpData.length > 0 &&
                                            <TableComponent columns={this.state.vpColumns} data={this.state.vpData} isLoading={this.state.isVpTableLoading} />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                {
                                    this.state.vpDueAmount > 0 ?
                                        <button className="btn btn-success button-box-shadow" onClick={this.saveVendorPayment}>
                                            <i className="fa-solid fa-circle-check"></i> Save
                                        </button>
                                        :
                                        <button className="btn btn-success button-box-shadow disabled">
                                            <i className="fa-solid fa-circle-check"></i> Save
                                        </button>
                                }

                                <button className="btn btn-secondary button-box-shadow" onClick={this.closeVendorPayModal}>
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Vendor payment modal section --> */}


                {/* <!-- Spot payment modal section --> */}
                <div className={this.state.showSpotPayModal === true ? "modal show-modal  modalWrapper" : "modal"}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    Manage Spot Payment
                                </h3>
                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeSpotPayModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <form>
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <label className="form-label">Vendor Name <span className='text-danger'>*</span></label>
                                                <select
                                                    name="spVendorId"
                                                    value={this.state.spVendorId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeSpotPayHandler}>
                                                    <option value="">-- Select --</option>
                                                    {this.state.spVendorData.map((item, index) => (
                                                        <option key={index} value={item.VendorId}>
                                                            {item.VendorName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Travel Circuit</label>
                                                <input type="text"
                                                    name="spTravelCircuitName"
                                                    className="form-control-sm border border-primary w-100"
                                                    disabled
                                                    value={this.state.spTravelCircuitName}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Location</label>
                                                <input type="text"
                                                    name="spLocationName"
                                                    className="form-control-sm border border-primary w-100"
                                                    disabled
                                                    value={this.state.spLocationName}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Vendor Category</label>
                                                <input type="text"
                                                    name="spVendorCategoryName"
                                                    className="form-control-sm border border-primary w-100"
                                                    disabled
                                                    value={this.state.spVendorCategoryName}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Payment Date <span className='text-danger'>*</span></label>
                                                <input type="date"
                                                    name="spPaymentDate"
                                                    className="form-control-sm border border-primary w-100"
                                                    value={this.state.spPaymentDate}
                                                    onChange={this.onChangeSpotPayHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Amount <span className='text-danger'>*</span></label>
                                                <input type="number"
                                                    name="spSpotAmount"
                                                    className="form-control-sm border border-primary w-100"
                                                    value={this.state.spSpotAmount}
                                                    onChange={this.onChangeSpotPayHandler} />
                                            </div>
                                            <div className="col-md-12">
                                                <label className="form-label">Comments</label>
                                                <textarea
                                                    name="spComment"
                                                    className="form-control border border-secondary"
                                                    rows="2"
                                                    value={this.state.spComment}
                                                    onChange={this.onChangeSpotPayHandler}></textarea>
                                            </div>
                                            <div className="col-md-12">
                                                <table style={{ width: '25%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td className='pt-2'><label className="form-label">Amount Paid ? </label></td>
                                                            <td>
                                                                <div className="form-check form-switch mt-1">
                                                                    <input type="checkbox"
                                                                        name="spIsAmountPaid"
                                                                        className="form-check-input"
                                                                        checked={this.state.spIsAmountPaid}
                                                                        onChange={this.onChangeSpotPayHandler}
                                                                        style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-sm-12">
                                        {
                                            this.state.spData.length > 0 &&
                                            <TableComponent columns={this.state.spColumns} data={this.state.spData} isLoading={this.state.isSpTableLoading} />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button className="btn btn-success button-box-shadow" onClick={this.saveSpotPayment}>
                                    <i className="fa-solid fa-circle-check"></i> Save
                                </button>
                                <button className="btn btn-secondary button-box-shadow" onClick={this.spotPayResetFields}>
                                    <i className="fa-solid fa-circle-xmark"></i> Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Spot payment modal section --> */}


                {this.openSubBookingModal()}

                <MoneyReceiptPreviewModal
                    show={this.state.showMoneyReceiptModal}
                    data={this.state.moneyReceiptData}
                    onClose={this.closeMoneyReceiptModal}
                />

                <ConfirmationVoucherPreviewModal
                    show={this.state.showConfirmationVoucherModal}
                    data={this.state.confirmationVoucherData}
                    onClose={this.closeConfirmationVoucherModal}
                />

                <HotelVoucherPreviewModal
                    show={this.state.showHotelVoucherModal}
                    data={this.state.hotelVoucherData}
                    onClose={this.closeHotelVoucherModal}
                />

            </>
        );
    }
}

export default ManageBooking;
